/**
 * Les textes de l'interface, en français et en anglais (langue du navigateur).
 * Règle du produit (doc 5 §5.1) : on parle montage, jamais technique.
 */

const fr = {
  "build.steps": "Étapes du montage",
  "build.waiting": "Ton montage va démarrer",
  "build.waitHint": "Le démarrage peut prendre quelques minutes. Tu peux quitter cet écran : le montage continue et chaque étape apparaîtra ici.",
  "build.elapsed": "Temps écoulé · {time}",
  "build.previewHint": "Aperçu de travail : le montage IA et ses vérifications continuent. La V1 sera disponible à la fin.",
  "build.applied": "Ce que le montage suit",
  "build.cancel": "Annuler le montage",
  "build.cancelTitle": "Annuler ce montage ?",
  "build.cancelHint": "Le montage s’arrête à sa prochaine étape. Tes fichiers et tes choix sont gardés : tu pourras relancer.",
  "build.cancelKeep": "Continuer le montage",
  "build.cancelConfirm": "Annuler",
  "build.phase.preparing": "Préparer les fichiers",
  "build.phase.transcribing": "Transcrire la parole",
  "build.phase.selecting": "Choisir les prises",
  "build.phase.planning": "Composer le montage IA",
  "build.phase.rendering": "Créer la vidéo",
  "build.phase.checking": "Vérifier et préparer la lecture",



  "projects.status.storyboard": "Storyboard",
  "carousel.palette": "Couleurs du modèle (sinon celles de ton kit)",
  "insp.themes": "Thèmes",
  "insp.spaces": "Espaces de la galerie",
  "insp.space.foryou": "Explorer",
  "insp.exploreLead": "Ton prochain montage commence ici.",
  "insp.spotlight": "À essayer avec tes plans",
  "insp.space.reels": "Reels",
  "insp.space.tiktok": "TikTok",
  "insp.space.shorts": "Shorts",
  "insp.space.youtube": "YouTube",
  "insp.space.carousels": "Carrousels",
  "insp.seeAll": "Tout voir",
  "insp.heroPick": "Choisir le template à la une",
  "insp.useCarousel": "Utiliser ce carrousel",
  "carousel.imagesCount": "{n} images",
  "carousel.new": "Nouveau carrousel",
  "carousel.intro": "Une idée par ligne : editit en fait une couverture, une image par idée et une image de fin, aux couleurs de ton kit. Tu modifies ensuite chaque page.",
  "carousel.title": "Titre de la couverture",
  "carousel.titleHint": "Ex. : 5 erreurs qui tuent ton reel",
  "carousel.ideas": "Tes idées",
  "carousel.ideasHint": "Une idée par ligne\nEx. : Le hook arrive trop tard : les 2 premières secondes décident.",
  "carousel.count": "{ideas} idées → {pages} images",
  "carousel.countNone": "Écris au moins une idée.",
  "carousel.create": "Créer le carrousel",
  "carousel.creating": "Création…",
  "carousel.readOnly": "Tu peux consulter ce carrousel ; seuls les monteurs le modifient.",
  "carousel.missing": "Ce projet n'a pas encore de carrousel.",
  "carousel.untitled": "Carrousel",
  "carousel.format": "Format",
  "carousel.format.portrait-feed": "fil Instagram",
  "carousel.format.square-feed": "carré",
  "carousel.format.vertical-talking-head": "plein écran",
  "carousel.style": "Allure",
  "carousel.style.bold": "Impact",
  "carousel.style.editorial": "Éditorial",
  "carousel.style.clean": "Épuré",
  "carousel.style.film": "Argentique",
  "carousel.style.scrapbook": "Carnet",
  "carousel.style.coquette": "Coquette",
  "carousel.style.academia": "Dark academia",
  "carousel.style.minimal": "Minimal",
  "carousel.kitDefault": "Kit de l'espace",
  "carousel.export": "Télécharger",
  "carousel.exporting": "Préparation…",
  "carousel.saving": "Enregistrement…",
  "carousel.unsaved": "Modifications à enregistrer",
  "carousel.saved": "{n} images enregistrées",
  "carousel.conflict": "Ce carrousel a changé sur un autre écran. Recharge-le pour reprendre la dernière version.",
  "carousel.reload": "Recharger",
  "carousel.pages": "Les images, dans l'ordre",
  "carousel.pageN": "Image {n} : {title}",
  "carousel.add": "Ajouter une image",
  "carousel.pageOf": "Image {n} sur {total}",
  "carousel.layout": "Mise en page",
  "carousel.layout.cover": "Couverture",
  "carousel.layout.point": "Idée",
  "carousel.layout.quote": "Citation",
  "carousel.layout.image": "Image",
  "carousel.layout.end": "Fin",
  "carousel.layout.photo": "Photo",
  "carousel.layout.polaroid": "Polaroid",
  "carousel.layout.collage": "Collage",
  "carousel.layout.moodboard": "Moodboard",
  "carousel.layout.note": "Carnet",
  "carousel.photos": "Photos de la page",
  "carousel.photoSlot": "Case {n}",
  "carousel.photoEmpty": "Choisir",
  "carousel.photoRemove": "Retirer la photo",
  "carousel.freePhotos": "Photos libres",
  "carousel.freePhotosHint": "Libres de droits (CC0), à publier sans crédit.",
  "carousel.myImages": "Ma bibliothèque",
  "carousel.pageTitle": "Titre",
  "carousel.body": "Texte",
  "carousel.author": "Auteur",
  "carousel.quote": "Citation",
  "carousel.image": "Photo de la bibliothèque",
  "carousel.imageNeeded": "Choisis une photo (PNG ou JPEG) : la page s'enregistre ensuite.",
  "carousel.noImages": "Ajoute des photos dans la Bibliothèque pour les utiliser ici.",
  "carousel.before": "Avant",
  "carousel.after": "Après",
  "carousel.addAfter": "Image après",
  "carousel.remove": "Retirer",
  "carousel.settings": "Format, allure et kit",
  "carousel.numbered": "Numéroter les images (2/7)",
  "projects.status.carousel": "Carrousel",
  "story.title": "Storyboard",
  "story.new": "Créer une vidéo depuis une idée",
  "story.start": "Créer le storyboard",
  "story.intro": "Prépare tes références et trois scènes. Tu valideras le coût avant toute génération vidéo.",
  "story.idea": "Idée",
  "story.objective": "Objectif",
  "story.references": "Références fixes",
  "story.refHint": "Personnages, produits, décors et style : choisis une image et décris ce qui doit rester identique.",
  "story.addRef": "Ajouter une référence",
  "story.name": "Nom",
  "story.description": "Détails à conserver",
  "story.image": "Image de référence",
  "story.chooseImage": "Choisir une image",
  "story.import": "Importer une image",
  "story.approve": "Valider les références",
  "story.approved": "Références validées",
  "story.unapproved": "Références à valider avant la vidéo",
  "story.scenes": "Scènes",
  "story.scene": "Scène {n}",
  "story.addScene": "Ajouter une scène",
  "story.sceneTitle": "Titre de la scène",
  "story.action": "Action",
  "story.camera": "Caméra",
  "story.custom": "Autre cadrage",
  "story.direction": "Indications de mise en scène",
  "story.duration": "Durée (s)",
  "story.up": "Monter la scène",
  "story.down": "Descendre la scène",
  "story.remove": "Retirer",
  "story.save": "Enregistrer",
  "story.saved": "Enregistré · révision {n}",
  "story.draft": "Modifications sur cet appareil · à enregistrer",
  "story.saving": "Enregistrement…",
  "story.conflict": "Une autre sauvegarde existe. Ton brouillon est conservé ici. Recharge la version enregistrée pour repartir de celle-ci.",
  "story.reload": "Recharger la version enregistrée",
  "story.discard": "Remplacer ton brouillon par la version enregistrée ?",
  "story.storage": "Le brouillon ne peut pas être gardé sur cet appareil. Enregistre avant de quitter.",
  "story.sketch": "Croquis et placement",
  "story.sketchImage": "Croquis de la scène",
  "story.layout": "Vue de dessus",
  "story.layoutHint": "Choisis un sujet ou la caméra, puis touche le schéma pour le placer. Les curseurs permettent aussi un réglage au clavier.",
  "story.place": "Élément à placer",
  "story.horizontal": "Position horizontale",
  "story.vertical": "Position verticale",
  "story.angle": "Orientation de la caméra (°)",
  "story.enableLayout": "Ajouter un placement",
  "story.removeLayout": "Retirer le placement",
  "story.noRefs": "Ajoute des références avant de préparer les scènes.",
  "story.savedFirst": "Enregistre les scènes et valide les références avant de demander un devis.",
  "story.unavailable": "La création de plans vidéo n'est pas encore ouverte sur ton compte. Tu peux préparer et enregistrer ton storyboard.",
  "story.generate": "Créer cette scène",
  "story.variants": "Variantes de la scène",
  "story.oldVariant": "Issue de la révision {n}",
  "story.assemblyPending": "L’assemblage des scènes dans le montage sera disponible dans une prochaine étape.",
  "story.toEdit": "Ouvrir le montage",
  "story.readOnly": "Tu peux consulter ce storyboard. Seuls les monteurs peuvent le modifier.",
  "story.formatUnsupported": "Le format 4:5 est enregistrable ; sa génération vidéo n’est pas disponible.",
  "story.refRequired": "Une image, un nom et une description sont nécessaires pour chaque référence.",
  "story.total": "{n} scènes · {s} s prévues",

  "transform.reload": "Recharger le montage actuel",
  "transform.cancelledCost": "Réservation libérée avant envoi",
  "transform.variations": "Variantes",
  "transform.title": "Transformer ce plan",
  "transform.scope": "Modifier l’image de cet extrait. La voix, les sous-titres et le montage sont conservés.",
  "transform.destination": "Plan de destination",
  "transform.clip": "Plan {n}",
  "transform.from": "Début du passage (s)",
  "transform.to": "Fin du passage (s)",
  "transform.rangeHint": "Choisis 4 à 30 secondes pour une nouvelle génération. L’application ajuste la variante à la durée choisie.",
  "transform.action": "Transformation",
  "transform.instruction": "Ce qui doit changer à l'image",
  "transform.references": "Références visuelles ({n})",
  "transform.referenceHint": "Images de personnage, produit, décor ou style. Elles guident la transformation du seul extrait choisi.",
  "transform.imageLimit": "Choisis une image PNG, JPEG ou WebP de 20 Mo maximum.",
  "transform.referenceLimit": "Les références doivent totaliser 32 Mo maximum.",
  "transform.role": "Rôle de {name}",
  "transform.role.character": "Personnage",
  "transform.role.product": "Produit",
  "transform.role.scene": "Décor",
  "transform.role.style": "Style",
  "transform.upload": "Importer une référence",
  "transform.unavailable": "Les variantes ne sont pas encore ouvertes sur ton compte. Celles déjà créées restent disponibles ci-dessous.",
  "transform.checkSend": "Vérifier l’envoi",
  "transform.uncertain": "La réponse à l’envoi est incertaine. Cette demande est conservée ; ne relance pas une nouvelle création.",
  "transform.oneAtATime": "Une variante est en cours. Tu peux continuer le montage pendant sa création.",
  "transform.maxCost": "Coût maximal réservé : {amount}. Une seule variante sera créée.",
  "transform.create": "Créer une variante — jusqu’à {amount}",
  "transform.estimate": "Estimer le coût",
  "transform.history": "Variantes de ce montage",
  "transform.empty": "Aucune variante pour le moment.",
  "transform.reservedCost": "Plafond réservé : {amount} · coût final en attente",
  "transform.actualCost": "Coût final : {amount}",
  "transform.compare": "Comparer au montage",
  "transform.applied": "Appliquée à ce plan",
  "transform.before": "Montage actuel",
  "transform.after": "Avec la variante",
  "transform.position": "Position dans l’aperçu",
  "transform.adjustment": "Vidéo reçue : {generated} s → extrait : {target} s · vitesse ×{rate}. Voix et sous-titres conservés.",
  "transform.confirmDestination": "Le montage a changé. Je confirme le plan {n} de {v} comme destination.",
  "transform.apply": "Appliquer dans une nouvelle version",
  "transform.status.reserved": "En attente",
  "transform.status.submitting": "Envoi en cours",
  "transform.status.unknown": "Envoi à vérifier",
  "transform.status.running": "Création en cours",
  "transform.status.retrieving": "Préparation de l’aperçu",
  "transform.status.succeeded": "Variante prête",
  "transform.status.failed": "Création interrompue",
  "transform.status.cancelled": "Annulée",
  "transform.preset.close": "Gros plan",
  "transform.prompt.close": "Rapprocher le cadre sur le sujet principal. Préserver son identité, son action et le décor.",
  "transform.preset.wide": "Plan large",
  "transform.prompt.wide": "Élargir le cadre autour du sujet principal, caméra stable. Préserver son identité, son action et le style du décor.",
  "transform.preset.profile": "Profil",
  "transform.prompt.profile": "Montrer le sujet de profil. Préserver son identité, son action, le décor et la lumière.",
  "transform.preset.high": "Plongée",
  "transform.prompt.high": "Placer la caméra légèrement au-dessus du sujet, inclinée vers le bas. Préserver son identité, son action et le décor.",
  "transform.preset.low": "Contre-plongée",
  "transform.prompt.low": "Placer la caméra légèrement sous le sujet, inclinée vers le haut. Préserver son identité, son action et le décor.",
  "transform.preset.tracking": "Travelling",
  "transform.prompt.tracking": "Ajouter un travelling latéral lent autour du sujet. Préserver son identité, son action et le décor.",
  "transform.preset.fixed": "Caméra fixe",
  "transform.prompt.fixed": "Stabiliser la caméra en plan fixe. Préserver le sujet, son action, le cadrage et le décor.",
  "transform.preset.motion": "Mouvement",
  "transform.prompt.motion": "Faire avancer doucement la caméra vers le sujet. Préserver son identité, son action et le décor.",
  "transform.preset.scene": "Décor",
  "transform.prompt.scene": "Changer le décor pour un studio lumineux sobre. Préserver le sujet, son action, son cadrage et ses couleurs.",
  "transform.preset.subject": "Sujet",
  "transform.prompt.subject": "Modifier la tenue du sujet en une veste bleu marine. Préserver son identité, son action, le cadrage et le décor.",
  "transform.preset.free": "Instruction libre",
  "transform.prompt.free": "",
  "common.back": "Retour",
  "common.close": "Fermer",
  "common.retry": "Réessayer",
  "common.cancel": "Annuler",
  "common.decimal": ",",
  "common.loading": "Un instant…",
  "common.signOut": "Se déconnecter",
  "error.network": "Je n'arrive pas à joindre editit. Vérifie ta connexion, je réessaie tout seul.",
  "error.generic": "Quelque chose n'a pas marché : {msg}",
  "error.notFound": "Je ne trouve pas ce montage. Il a peut-être été supprimé.",
  "error.notYet": "Cette partie n'est pas encore branchée de mon côté. Réessaie un peu plus tard.",
  "error.auth": "Ta session a expiré. Reconnecte-toi.",
  "error.rules": "Ce changement ne passe pas : il casserait le montage.",
  "error.rule.onHook": "Pas sur l'accroche : place-le un peu plus loin.",
  "error.rule.overlap": "Il y a déjà un élément à cet endroit.",
  "error.rule.pastEnd": "Ça dépasse la fin de la vidéo.",
  "error.rule.dose": "Il y en a déjà assez de ce genre dans la vidéo.",
  "error.rule.empty": "Il faut garder au moins un plan.",
  "login.subtitle": "Dépose tes rushes, je te rends un montage prêt à publier.",
  "login.email": "Adresse e-mail",
  "login.password": "Mot de passe",
  "login.submit": "Se connecter",
  "login.google": "Continuer avec Google",
  "login.dev": "Entrer en mode local",
  "login.devHint": "Pas de compte configuré ici : tu travailles sur l'espace de test local.",
  "login.bad": "E-mail ou mot de passe incorrect.",
  "kind.main_cam": "Caméra",
  "kind.mic": "Micro",
  "kind.screen": "Écran",
  "kind.broll": "Plan de coupe",
  "kind.image": "Image",
  "kind.logo": "Logo",
  "kind.music": "Musique",
  "brand.title": "Marque",
  "brand.subtitle": "Tes couleurs, ta police, ton logo : appliqués à chaque montage.",
  "brand.identity": "Identité",
  "brand.name": "Nom",
  "brand.namePlaceholder": "Par exemple : Studio Lumière",
  "brand.handle": "Compte affiché",
  "brand.handlePlaceholder": "@toncompte",
  "brand.handleHint": "En haut de l'image, pendant toute la vidéo. Vide : rien.",
  "brand.logo": "Logo",
  "brand.logoAdd": "Ajouter un logo",
  "brand.logoChange": "Changer",
  "brand.logoRemove": "Retirer",
  "brand.logoHint": "PNG transparent.",
  "brand.logoFailed": "Le logo n'est pas parti. Réessaie.",
  "brand.colors": "Couleurs",
  "brand.accent": "Accent",
  "brand.accentHint": "Titres, chiffres, mot actif des sous-titres",
  "brand.bg": "Fond",
  "brand.bgHint": "Derrière les cartes et la fin",
  "brand.text": "Texte",
  "brand.textHint": "Sous-titres et titres",
  "brand.other": "Autre couleur",
  "brand.hex": "Code couleur de {what}",
  "brand.font": "Police",
  "brand.font.modern": "Moderne",
  "brand.font.geometric": "Géométrique",
  "brand.font.rounded": "Arrondie",
  "brand.font.impact": "Impact",
  "brand.font.serif": "Classique",
  "brand.font.mono": "Machine",
  "brand.cta": "Carte de fin",
  "brand.ctaHint": "Le même mot d'une vidéo à l'autre : c'est la répétition qui en fait un réflexe. Vide, je le choisis selon la vidéo.",
  "brand.ctaWord": "Mot à commenter",
  "brand.ctaWordPlaceholder": "GUIDE",
  "brand.ctaLead": "Au-dessus",
  "brand.ctaLeadPlaceholder": "commente",
  "brand.ctaButton": "Bouton",
  "brand.ctaButtonPlaceholder": "envoyer",
  "brand.captions": "Sous-titres",
  "brand.case": "Casse",
  "brand.uppercase": "MAJUSCULES",
  "brand.normalCase": "Normale",
  "brand.activeWord": "Mot actif",
  "brand.activeWord.accent": "Accent",
  "brand.save": "Enregistrer",
  "brand.saving": "J'enregistre…",
  "brand.saved": "Enregistré. Tes montages suivent, jusqu'aux rendus.",
  "brand.unsaved": "Pas encore enregistré",
  "brand.preview": "Aperçu",
  "brand.previewLive": "en direct",
  "brand.previewHint": "Une vidéo type avec ta marque. Touche pour lire.",
  "brand.jump.hook": "Accroche",
  "brand.jump.title": "Titre",
  "brand.jump.name": "Nom",
  "brand.jump.number": "Chiffre",
  "brand.jump.end": "Fin",
  "brand.readOnly": "Seuls les monteurs de l'espace peuvent changer la marque.",
  "build.closeHint": "Tu peux fermer cette page : le montage continue.",
  "build.failed": "Le montage s'est arrêté",
  "failure.action.showcase": "Essayer le mode vitrine",
  "failure.action.reupload": "Renvoyer le fichier",
  "failure.action.relabel": "Revoir les rushes",
  "failure.action.shorter": "Raccourcir les rushes",
  "failure.action.retry": "Réessayer",
  "reason.slate": "début de prise",
  "reason.retake": "reprise, j'ai gardé la suivante",
  "reason.abandoned": "phrase abandonnée",
  "reason.sliver": "fragment trop court",
  "reason.silence": "silence",
  "reason.manual": "retiré à la main",
  "player.video": "La vidéo",
  "player.heavy": "Première lecture : la vidéo peut mettre un peu de temps à venir.",
  "player.play": "Lecture",
  "player.pause": "Pause",
  "player.fullscreen": "Plein écran",
  "player.exitFullscreen": "Quitter le plein écran",
  "player.loading": "Je prépare la lecture…",
  "player.unavailable": "La lecture n'est pas encore disponible pour cette version.",
  "player.pinAt": "à cet endroit de l'image",
  "player.pinText": "Dis ce qui ne va pas…",
  "player.chip.cut": "Coupe ici",
  "player.chip.remove": "Enlève",
  "player.chip.shorter": "Plus court",
  "player.chip.bigger": "Plus gros",
  "player.chip.otherImage": "Autre image",
  "player.removePin": "Retirer ce retour",
  "player.hold": "Maintenir pour parler",
  "player.recording": "Je t'écoute… relâche pour finir",
  "player.voiceSaved": "Retour vocal",
  "player.voiceDenied": "Je n'ai pas accès au micro. Autorise-le dans ton navigateur, ou écris ton retour.",
  "player.grouped": "Tes retours partent ensemble : une seule {v}, avec la liste de ce qui a été fait.",
  "player.send": "Envoyer {n} retours",
  "player.sendOne": "Envoyer 1 retour",
  "player.sendNone": "Envoyer les retours",
  "player.reviseFailed": "Je n'ai pas réussi à faire la {v} : {msg}. Tes retours sont revenus dans la liste : renvoie-les ou reformule-les.",
  "player.sending": "Je prépare la {v}. Je te la montre dès qu'elle est prête.",
  "player.newVersion": "La {v} est prête.",
  "player.reviseNoChange": "L'IA n'a rien trouvé à changer avec ces retours. Ils sont revenus dans la liste : précise-les un peu et renvoie-les.",
  "player.reviseTimeout": "La {v} prend beaucoup plus de temps que prévu. Tes retours sont revenus dans la liste : tu peux les renvoyer.",
  "editor.voiceFailed": "Ta note vocale n'est pas partie. Réessaie dans un instant.",
  "player.changes.empty": "C'est la première version : pas encore de changement à montrer.",
  "player.changes.none": "Aucun changement listé pour cette version.",
  "player.changes.done": "Fait",
  "player.changes.notDone": "Pas fait",
  "player.changes.undo": "Annuler",
  "player.changes.undone": "Annulé : la {v} ne l'a plus.",
  "player.text.hint": "Touche un mot puis un autre pour sélectionner un passage, et coupe-le. Touche une phrase retirée pour la remettre.",
  "player.text.free": "Gratuit : aucun crédit.",
  "player.text.cut": "Couper",
  "player.text.quiet": "{n} silence(s) ou bout(s) de phrase retiré(s)",
  "player.text.willCut": "« {words} » sera coupé",
  "player.text.restore": "Remettre",
  "player.text.tighten": "Resserrer {n} pause(s) · −{s} s",
  "player.text.fillers": "Retirer {n} hésitation(s) · −{s} s",
  "player.text.autoHint": "Sans IA : les silences de plus d'une seconde se resserrent, les « euh » et « hum » se retirent.",
  "player.text.oldVersion": "Tu regardes une ancienne version : le texte se modifie sur la dernière ({v}).",
  "player.text.goLatest": "Aller à la {v}",
  "player.globalShort": "Toute la vidéo",
  "privacy.link": "Ce qu'on fait de vos vidéos",
  "privacy.title": "Ce qu'on fait de vos vidéos",
  "privacy.intro": "editit est en phase de test, sur invitation. Voici, simplement, où vont tes fichiers et combien de temps ils restent.",
  "privacy.storage.title": "Où sont tes fichiers",
  "privacy.storage.body": "Tes rushes sont stockés chez Cloudflare R2, dans un espace privé. Personne ne peut les ouvrir sans un lien signé, valable peu de temps, que seule l'app crée pour toi.",
  "privacy.retention.title": "Combien de temps on les garde",
  "privacy.retention.body": "Les fichiers que tu déposes sont supprimés automatiquement 3 jours après le dépôt. Les vidéos montées, 14 jours après leur création. Pense à télécharger ce que tu veux garder. Les logos, images, captures, plans de coupe et musiques rangés dans ta Bibliothèque y restent jusqu'à ce que tu les retires.",
  "privacy.ai.title": "Qui les traite",
  "privacy.ai.body": "Ce que tu dis est transcrit par Groq (Whisper). Les choix de montage (ce qu'on coupe, ce qu'on ajoute) sont faits par des modèles de langage (DeepSeek), à partir du texte. Nous n'utilisons rien de tes vidéos pour entraîner un modèle.",
  "privacy.quotas.title": "Les limites de la phase de test",
  "privacy.quotas.body": "Par période de 30 jours : 20 montages, 30 exports, 100 tours de retours. Fichiers de 2 Go au maximum.",
  "privacy.delete.title": "Tout supprimer tout de suite",
  "privacy.delete.body": "Écris à Greg{contact} : on efface tes fichiers et tes montages sans attendre.",
  "export.formats": "Formats",
  "export.srt": "Fichier de sous-titres (.srt)",
  "export.song.title": "Son à ajouter dans Instagram ou TikTok",
  "export.song.copy": "Copier le nom du son",
  "export.song.copied": "Copié",
  "export.song.instagram": "Ouvrir Instagram",
  "export.song.tiktok": "Ouvrir TikTok",
  "export.song.start": "Ta vidéo prend le morceau à",
  "export.song.origin": "Son d'origine dans TikTok — calé pile",
  "export.song.origin1": "Ouvre le son d'origine : TikTok montre la vidéo dont vient le template.",
  "export.song.origin2": "Touche le disque qui tourne, puis « Utiliser ce son ».",
  "export.song.origin3": "Touche « Importer » et choisis ta vidéo : le son démarre pile sur tes coupes.",
  "export.song.mode": "Son du commerce",
  "export.song.inVideo": "Dans la vidéo",
  "export.song.inApp": "À ajouter dans l'app",
  "export.song.included": "« {name} » inclus dans la vidéo — usage personnel",
  "export.song.personal":
    "Musique du commerce incluse pour un usage personnel uniquement. Pour publier sur TikTok ou Instagram, exporte sans elle et ajoute le son dans l'app : sinon la vidéo peut être rendue muette ou retirée.",
  "export.song.span": "À ajouter dans TikTok ou Instagram de {from} à {to} de ta vidéo",
  "export.song.spanFrom": "À ajouter dans TikTok ou Instagram à partir de {from} de ta vidéo",
  "export.sound.original": "Son d'origine inclus dans la vidéo, calé pile sur tes coupes.",
  "export.sound.platforms": "Si Instagram ou TikTok coupent le morceau, ajoute-le depuis l'app.",
  "export.sound.platformsAt": "Si Instagram ou TikTok coupent le morceau, ajoute-le depuis l'app (il commence à {at}).",
  "export.sound.music": "Musique incluse dans la vidéo.",
  "export.go": "Exporter",
  "export.ready": "Prête",
  "export.failed": "L'export a échoué : {msg}",
  "export.download": "Télécharger",
  "export.again": "Exporter dans un autre format",
  "time.justNow": "à l'instant",
  "time.minutes": "il y a {n} min",
  "time.hours": "il y a {n} h",
  "time.days": "il y a {n} j",
  "nav.label": "Navigation principale",
  "nav.library": "Bibliothèque",
  "common.save": "Enregistrer",
  "build.retry": "Réessayer",
  "player.preview": "Aperçu",

  // ——— La refonte créateurs (doc 12) ———
  "common.done": "OK",
  "nav.projects": "Vidéos",
  "nav.inspiration": "Inspiration",
  "nav.new": "Nouvelle vidéo",
  "nav.me": "Moi",

  "projects.untitled": "Projet du {date}",
  "projects.empty": "Aucun projet",
  "projects.menu": "Options de « {name} »",
  "projects.rename": "Renommer",
  "projects.retry": "Relancer le montage",
  "projects.delete": "Supprimer",
  "projects.delete.title": "Supprimer « {name} » ?",
  "projects.delete.body": "Les rushes, les versions et les exports de ce projet disparaissent.",
  "projects.delete.busy": "Le montage est en cours : attends qu'il se termine pour supprimer ce projet.",
  "projects.status.failed": "À reprendre",
  "projects.status.waitingFiles": "Brouillon · à monter",
  "projects.status.toWatch": "À publier",
  "projects.status.exported": "Enregistrée",

  "format.ratio.vertical-talking-head": "9:16",
  "format.ratio.vertical-split-card": "9:16 carte",
  "format.ratio.landscape-youtube": "16:9",
  "format.use.vertical-talking-head": "Face cam, plein écran",
  "format.use.vertical-split-card": "Face cam + écran",
  "format.use.landscape-youtube": "Vidéo longue, écran large",
  "format.ratio.square-feed": "1:1",
  "format.ratio.portrait-feed": "4:5",
  "format.use.square-feed": "Carré, pour un fil",
  "format.use.portrait-feed": "Portrait, pour un fil",

  "new.format": "Quel format ?",
  "new.template": "Template",
  "new.kit": "Kit",
  "new.none": "Aucun",
  "new.blockSending": "Tes rushes sont encore en route ({n}) : « Monter » sera prêt dès qu'ils seront arrivés.",
  "new.blockFailed": "« {name} » n'est pas envoyé : réessaie-le depuis sa vignette ou retire-le.",
  "new.blockMissing": "« {name} » n'est jamais arrivé en entier : redépose-le ou retire-le.",

  "footage.drop": "Dépose tous tes rushes",
  "footage.add": "Ajouter",
  "footage.fromLibrary": "Bibliothèque",
  "footage.sending": "Envoi de {n}…",
  "footage.sent": "Envoyé",
  "footage.paused": "Connexion perdue, je reprends…",
  "footage.failed": "Pas envoyé",
  "footage.tooBig": "Ce fichier fait {size} Go, le maximum est {max} Go.",
  "footage.durationUnknown": "durée inconnue",
  "footage.failedNetwork": "La connexion a lâché pendant l'envoi.",
  "footage.failedTooBig": "Ce fichier est trop gros pour être envoyé.",
  "footage.failedGeneric": "L'envoi n'a pas abouti.",
  "footage.failedPart": "Le morceau {n} du fichier n'a pas été confirmé par le stockage, même après trois essais. Réessaie.",
  "footage.kindOf": "Type de « {name} »",
  "footage.keep": "Garder dans la bibliothèque",
  "footage.alreadyKept": "Il est déjà dans ta bibliothèque.",
  "footage.duplicate": "Déjà dans le projet, pas renvoyé : {name}.",
  "footage.remove": "Retirer du projet",
  "footage.removeTitle": "Retirer « {name} » ?",
  "footage.removeHint": "Le rush quitte ce projet. Les versions déjà montées ne changent pas.",
  "footage.kept": "Rangé dans ta bibliothèque.",
  "footage.libraryEmpty": "Ta bibliothèque est vide.",
  "footage.librarySearch": "Chercher un média",
  "footage.libraryNoMatch": "Aucun média ne s'appelle « {query} ».",
  "section.camera": "Caméra",
  "section.mic": "Micro",
  "section.broll": "Plans de coupe",
  "section.screen": "Écran",
  "section.images": "Images",
  "section.music": "Musique",

  "project.segments": "Étapes du projet",
  "project.rushes": "Rushes",
  "project.montage": "Montage",
  "project.export": "Export",
  "project.exportBtn": "Exporter",
  "project.menu": "Options du projet",
  "project.saveAsTemplate": "Enregistrer comme template",
  "project.templateSaved": "C'est dans Mes templates.",
  "project.seeTemplates": "Voir",

  "build.changeFootage": "Changer les rushes",

  "editor.tools": "Outils",
  "editor.selection": "Sélection",
  "editor.undo": "Annuler",
  "editor.redo": "Rétablir",
  "editor.saved": "C'est fait.",
  "editor.saving": "Enregistrement…",
  "editor.versionSaved": "{v} enregistrée",
  "editor.song": "Son du montage : {name}. À l'export : dans la vidéo (usage personnel) ou à ajouter dans l'app.",
  "editor.undone": "Annulé.",
  "editor.redone": "Rétabli.",
  "editor.removed": "Supprimé.",
  "editor.viewing": "Tu regardes {v}.",
  "editor.restoreThis": "Revenir à celle-ci",
  "editor.goLatest": "Aller à {v}",
  "editor.oldVersion": "Tu regardes une ancienne version : les changements se font sur {v}.",

  "tl.video": "Vidéo",
  "tl.text": "Texte",
  "tl.overlays": "Éléments",
  "tl.cutaways": "Plans de coupe",
  "tl.audio": "Audio",
  "tl.clipAt": "Plan à {t}",
  "tl.gap": "Passage retiré",
  "tl.selectHint": "Sélectionner un plan",
  "check.flag": "À revoir",
  "check.shortShot": "Ce plan ne reste que {d} s à l’écran : il passe comme un éclair.",
  "check.shortCutaway": "Ce plan de coupe ne reste que {d} s à l’écran : trop court pour se voir.",
  "check.shortBetween": "Le plan ne revient que {d} s entre deux plans de coupe : on voit un éclair.",
  "check.black": "Écran noir de {from} à {to} : rien n’est posé à l’image.",
  "check.fix": "Corriger",
  "check.fixed": "Passage corrigé",
  "tl.selectedClip": "Plan {n} · {start}–{end}",
  "tl.zoom": "Zoom de la timeline",
  "tl.zoomIn": "Agrandir la timeline",
  "tl.zoomOut": "Réduire la timeline",
  "tl.zoomReset": "Réinitialiser le zoom de la timeline",

  "sel.split": "Couper ici",
  "sel.splitDone": "Coupé à {t}.",
  "sel.delete": "Supprimer",
  "sel.left": "Avant",
  "sel.right": "Après",
  "sel.restore": "Remettre",
  "sel.restored": "Remis.",
  "sel.edit": "Modifier",
  "sel.duration": "Durée",
  "sel.speed": "Vitesse",
  "sel.speedX": "{x}×",
  "sel.speedHint": "Plus lent pour savourer un moment, plus rapide pour passer vite sur une démo. La voix suit.",
  "sel.transition": "Transition",
  "sel.transitionHint": "Le passage qui amène ce plan, sur la coupe juste avant lui.",
  "transition.none": "Coupe franche",
  "transition.fade": "Fondu",
  "transition.whip": "Balayage",
  "transition.zoom": "Zoom",
  "transition.flash": "Flash",
  "transition.glitch": "Glitch",
  "cut.title": "Transition entre le plan {a} et le plan {b}",
  "cut.effect.none": "Le plan {a} s'arrête et le plan {b} commence net, sans effet.",
  "cut.effect.fade": "Le plan {b} sort du noir. Le plan {a} s'arrête net : ce n'est pas un fondu enchaîné.",
  "cut.effect.whip": "Le plan {a} file vers la gauche et le plan {b} arrive par la droite, flous, comme un coup de caméra rapide.",
  "cut.effect.zoom": "Le plan {b} arrive zoomé et flou, puis se pose.",
  "cut.effect.flash": "Un éclair blanc couvre la coupe entre les deux plans.",
  "cut.effect.glitch": "Le plan {b} arrive en saccades, couleurs décalées, comme un écran qui grésille.",
  "cut.where.none": "Rien ne se joue : l'image passe d'un plan à l'autre d'un coup.",
  "cut.where.after": "Sur le début du plan {b} : {after} juste après la coupe. Le plan {a} n'est pas touché.",
  "cut.where.around": "À cheval sur la coupe : la fin du plan {a} ({before}) et le début du plan {b} ({after}).",
  "cut.follows": "Elle reste avec le plan {b} : s'il change de place, elle part avec lui.",
  "cut.restore": "Remettre le passage coupé entre le plan {a} et le plan {b} ({d})",
  "cut.restored": "Passage remis entre les deux plans.",
  "tool.zoom": "Zoom",
  "tool.zoom.added": "Zoom posé à {t}.",
  "emphasis.title": "Mettre en avant",
  "emphasis.big": "Plus gros",
  "emphasis.color": "En couleur",
  "emphasis.emoji": "Avec un emoji",
  "emphasis.none": "Plus en avant",
  "emphasis.hint": "Le mot « {word} » ressort dans les sous-titres.",
  "sel.change": "Changer",
  "sel.hideCaptions": "Masquer",
  "sel.look": "Image",
  "sel.style": "Style",
  "sel.passage": "Passage",
  "passage.title": "Passage",
  "passage.kept": "Passage gardé : {a} → {b} · {d}",
  "passage.loading": "Lecture du film…",
  "passage.whole": "Le film est plus court que le plan : il est pris en entier.",
  "passage.drag": "Glisse le bloc jaune sur le morceau à garder (‹ › ou ← → : un dixième).",
  "passage.rushNote": "Le son et les sous-titres suivent l'extrait ; le plan garde sa durée et sa place.",
  "passage.replacementNote": "La voix du plan reste ; seule l'image change.",
  "passage.apply": "Valider ce passage",
  "passage.earlier": "Un dixième plus tôt",
  "passage.later": "Un dixième plus tard",
  "passage.missing": "Le film de ce plan n'est pas encore chargé. Lance la lecture, puis réessaie.",
  "passage.done": "Passage du plan · {a} → {b}",
  "look.volume": "Son du plan",
  "look.volumeHint": "La voix et le son de ce plan seulement. 100 % : tel quel.",
  "look.voice": "Voix",
  "look.voiceClean": "Nettoyer la voix",
  "look.voiceHint": "Pour tous les plans : la voix isolée de son bruit de fond, plus présente et plus égale. 0 % : telle quelle.",
  "look.voiceStyle": "Couleur de la voix",
  "voice.normal": "Normale",
  "voice.brillant": "Brillante",
  "voice.studio": "Studio",
  "voice.studioHint": "Chaude et proche, comme un micro de studio.",
  "look.percent": "{x} %",
  "look.adjust": "Réglages",
  "reset.label": "Réinitialiser",
  "reset.all": "Tout réinitialiser",
  "reset.aria": "Réinitialiser {what}",
  "reset.planDone": "Plan remis à zéro : vitesse, son, image et cadrage d'origine",
  "reset.what.speed": "la vitesse",
  "reset.done.speed": "Vitesse normale",
  "reset.what.volume": "le volume",
  "reset.done.volume": "Volume d'origine",
  "reset.what.adjust": "les réglages",
  "reset.done.adjust": "Réglages remis à zéro",
  "reset.what.filter": "le filtre",
  "reset.done.filter": "Filtre retiré",
  "reset.what.frame": "le cadrage",
  "reset.done.frame": "Cadrage d'origine",
  "reset.what.move": "le mouvement",
  "reset.done.move": "Mouvement retiré",
  "reset.what.transition": "la transition",
  "reset.done.transition": "Coupe franche",
  "reset.what.textStyle": "le style",
  "reset.done.textStyle": "Style d'origine rétabli",
  "reset.what.place": "la position",
  "reset.done.place": "Remis à sa place",
  "reset.what.keyframes": "les images clés",
  "reset.done.keyframes": "Images clés retirées : l'élément reste à sa place",
  "reset.what.insertLook": "le fond et le cadre",
  "reset.done.insertLook": "Fond et cadre d'origine",
  "reset.what.voice": "la voix",
  "reset.done.voice": "Voix telle quelle",
  "reset.what.captionPlace": "la place des sous-titres",
  "reset.done.captionPlace": "Sous-titres à leur place",
  "adjust.brightness": "Luminosité",
  "adjust.contrast": "Contraste",
  "adjust.saturation": "Saturation",
  "adjust.warmth": "Chaleur",
  "adjust.vignette": "Vignettage",
  "look.filters": "Filtres",
  "look.intensity": "Intensité",
  "filter.none": "Aucun",
  "filter.vivid": "Éclatant",
  "filter.warm": "Chaud",
  "filter.cool": "Froid",
  "filter.vintage": "Vintage",
  "filter.fade": "Délavé",
  "filter.mono": "N&B",
  "filter.noir": "Noir",
  "filter.drama": "Dramatique",
  "look.orient": "Orientation",
  "look.mirror": "Miroir",
  "look.rotate": "Pivoter · {deg}°",
  "look.trim": "Rogner",
  "look.trimFrom": "Début dans le rush (s)",
  "look.trimTo": "Fin dans le rush (s)",
  "look.trimHint": "Tu peux aussi allonger le plan, jusqu'au bout du rush : la parole retrouvée revient.",
  "look.trimApply": "Appliquer",
  "textStyle.font": "Police",
  "textStyle.color": "Couleur",
  "textStyle.background": "Fond",
  "textStyle.noBackground": "Sans fond",
  "textStyle.align": "Alignement",
  "align.left": "À gauche",
  "align.center": "Centré",
  "align.right": "À droite",
  "place.title": "Position",
  "place.auto": "Position auto",
  "place.hint": "Glisse l'élément sur l'image, ou choisis une case.",
  "place.done": "Déplacé",
  "place.reset": "Remis à sa place",
  "place.cell.0": "En haut à gauche",
  "place.cell.1": "En haut",
  "place.cell.2": "En haut à droite",
  "place.cell.3": "À gauche",
  "place.cell.4": "Au centre",
  "place.cell.5": "À droite",
  "place.cell.6": "En bas à gauche",
  "place.cell.7": "En bas",
  "place.cell.8": "En bas à droite",
  "behind.label": "Derrière la personne",
  "behind.hint": "Le texte passe derrière toi : tu restes devant.",
  "behind.preparing": "Préparation du détourage… le texte reste devant en attendant.",
  "behind.ready": "Détourage prêt.",
  "behind.failed": "Le détourage n'a pas abouti.",
  "behind.retry": "Réessayer",
  "sfx.title": "Son posé",
  "sfx.moveHere": "Placer à {t}",
  "sfx.volume": "Volume",
  "sfx.replace": "Remplacer par",
  "sfx.replaced": "Son remplacé.",
  "tool.music.start": "Passage du morceau",
  "tool.music.fadeIn": "Fondu d'entrée",
  "tool.music.fadeOut": "Fondu de sortie",
  "tool.music.seconds": "{x} s",
  "size.kb": "Ko",
  "size.mb": "Mo",
  "size.gb": "Go",
  "projects.duplicate": "Dupliquer",
  "projects.duplicating": "Je copie le montage…",
  "export.size": "Qualité",
  "export.hd": "HD",
  "export.uhd": "4K",
  "export.uhdNo45": "La 4K n'existe pas en 4:5 : retire ce format pour l'avoir.",
  "export.fps": "Images par seconde",
  "export.fpsX": "{x} i/s",
  "export.progress": "{pct} %",
  "export.waiting": "En attente de son tour…",

  "tool.style": "Style",
  "tool.captions": "Sous-titres",
  "tool.text": "Texte",
  "tool.elements": "Éléments",
  "tool.music": "Musique",
  "tool.sounds": "Sons",
  "tool.template": "Template",
  "template.hint": "Glisse un plan à sa place (au doigt, maintiens-le d'abord) : les durées restent celles du template.",
  "template.dropHere": "Lâche ici : case {n}, le plan durera {d}.",
  "template.textsHint": "Change les mots : la police, la place et le moment restent ceux du template.",
  "template.plans": "Plans",
  "template.texts": "Textes",
  "template.case": "Case {n}",
  "template.caseDuration": "{d} · durée du template",
  "template.caseLabel": "Case {n}, {d}",
  "template.replace": "Remplacer",
  "template.replaceHint": "Le plan choisi durera {d}, comme la case du template ; une vidéo trop courte est ralentie.",
  "template.fromDevice": "Choisir sur cet appareil",
  "template.fromLibrary": "Ta bibliothèque",
  "template.sending": "Envoi du plan… {p} %",
  "template.arranged": "Plans remis dans l'ordre · durées du template gardées",
  "template.replaced": "Plan remplacé · {d} comme dans le template",
  "template.textChanged": "Texte changé",
  "template.text": "Texte à {t}",
  "template.showText": "Voir ce texte dans la vidéo",
  "tool.ai": "IA",
  "tool.edit": "Montage",
  "tool.elements.stickers": "Autocollants",
  "tool.elements.stickerPlace": "Où le poser",
  "tool.elements.stickerAdd": "Poser à {t}",
  "tool.elements.stickerAdded": "Autocollant posé à {t}",
  "tool.elements.effects": "Effets",
  "tool.elements.grain": "Grain de film",
  "tool.elements.grainHint": "Sur toute la vidéo, comme une pellicule.",
  "tool.elements.grainOn": "Grain de film posé",
  "tool.elements.grainOff": "Grain de film retiré",
  "layout.title": "Mise en page",
  "layout.columns": "Colonnes",
  "layout.columnsHint": "De 2 à 6 plans côte à côte, d'un coup.",
  "layout.strip": "Bande qui défile",
  "layout.stripHint": "Tes plans côte à côte défilent toute la vidéo.",
  "layout.progress": "Barre de progression",
  "layout.progressHint": "Elle se remplit, un petit texte au-dessus.",
  "layout.shots": "Plans · {n}/{max}",
  "layout.shotsHint": "Choisis de 2 à 6 plans, dans l'ordre.",
  "layout.shotN": "Plan {n}",
  "layout.needTwo": "Il faut au moins 2 plans dans ta vidéo.",
  "layout.visible": "À l'écran",
  "layout.label": "Texte de la barre",
  "layout.labelPlaceholder": "Chargement",
  "layout.color": "Couleur",
  "layout.dots": "Points qui s'animent",
  "layout.addAll": "Ajouter sur toute la vidéo",
  "layout.addedAll": "{name} sur toute la vidéo.",
  "layout.settings": "Réglages",
  "instant.shelf": "Prêts en un instant",
  "instant.shelfHint": "Tes plans. Le rythme est déjà là.",
  "instant.badge": "Instantané",
  "instant.feed": "Templates instantanés",
  "instant.meta": "{n} plans · {t}",
  "instant.lead": "Jusqu'à {n} photos ou vidéos, dans l'ordre où elles passeront. Le rythme est déjà là.",
  "instant.previewOf": "Aperçu de {name}",
  "instant.empty": "Choisis jusqu'à {n} photos ou vidéos",
  "instant.full": "C'est complet : retire un plan pour en mettre un autre.",
  "instant.count": "{n}/{max} choisis",
  "instant.order": "Plan {n}",
  "instant.create": "Créer ma vidéo",
  "instant.sending": "Envoi de tes plans · {n}/{max}",
  "instant.building": "Ta vidéo se pose…",
  "instant.failed": "Ta vidéo n'a pas pu être posée.",
  "instant.missing": "Ce template n'est plus disponible.",
  "instant.withAi": "Monter avec l'IA",
  "instant.leadSound": "Jusqu'à {n} photos ou vidéos, dans l'ordre où elles passeront, sur le son de la vidéo d'origine.",
  "instant.textsTitle": "Tes textes",
  "instant.textsLead": "Garde ceux du template ou écris les tiens : même police, même place, même animation.",
  "instant.textsCount": "{n} textes",
  "instant.textSlots": "Plans {a} à {b}",
  "instant.textAll": "Toute la vidéo",
  "instant.textBar": "Barre",
  "instant.keepTexts": "Garder ces textes",
  "instant.silent": "Sans son",
  "sticker.place.topLeft": "Haut gauche",
  "sticker.place.topRight": "Haut droit",
  "sticker.place.center": "Centre",
  "sticker.place.bottomLeft": "Bas gauche",
  "sticker.place.bottomRight": "Bas droit",
  "tool.voiceover": "Voix off",
  "tl.voiceovers": "Voix off",
  "tl.selectedVoiceover": "Voix off · {start} → {end}",
  "tl.voiceoverAt": "Voix off à {t}",
  "tl.music": "Musique",
  "tl.musicAt": "{name} à {t}",
  "tl.moved": "Déplacé à {t}",
  "sel.move": "Mouvement",
  "sel.here": "Ici",
  "move.none": "Aucun",
  "move.zoomIn": "Zoom avant",
  "move.zoomOut": "Zoom arrière",
  "move.panLeft": "Vers la gauche",
  "move.panRight": "Vers la droite",
  "move.set": "Mouvement : {name}",
  "move.removed": "Mouvement retiré",
  "move.hint": "Un mouvement lent, tenu tout le plan, comme dans les templates.",
  "vo.hint": "Parle par-dessus ton montage, depuis la tête de lecture. Il défile sans son pendant que tu enregistres ; ta voix s'ajoute en piste, le montage garde sa longueur.",
  "vo.filmMe": "Me filmer aussi",
  "vo.filmMeHint": "Ton image se pose en vignette, en haut à droite ; tu pourras la déplacer.",
  "vo.record": "Enregistrer à {t}",
  "vo.asking": "J'attends ton micro…",
  "vo.recordingFrom": "Depuis {t}, le montage défile sans son",
  "vo.stop": "Arrêter",
  "vo.sending": "J'envoie ta voix off… {p} %",
  "vo.placed": "Voix off posée à {t}",
  "vo.placedFilmed": "Voix off et image posées à {t}",
  "vo.tooShort": "Prise trop courte : parle au moins une seconde.",
  "vo.denied": "Le micro est bloqué : autorise-le dans ton navigateur pour enregistrer.",
  "vo.deniedCamera": "La caméra ou le micro est bloqué : autorise-les dans ton navigateur pour te filmer.",
  "vo.unsupported": "Ce navigateur ne sait pas enregistrer : essaie Chrome, Safari ou l'app iPhone.",
  "vo.volume": "Volume",
  "vo.volumeSet": "Volume de la voix off : {p} %",
  "vo.volumeHint": "Le niveau de cette voix off ; 0 la coupe.",
  "vo.volumeBoost": "Au-delà de 100 % : amplifiée à l'export, l'aperçu la joue plus fort aussi.",
  "vo.splitDone": "Voix off coupée à {t}",
  "vo.image": "Image",
  "vo.layoutHidden": "Image de la voix off masquée",
  "vo.layoutSet": "Image de la voix off : {name}",
  "vo.layout.hidden": "Masquée",
  "vo.layout.top-left": "Haut gauche",
  "vo.layout.top-right": "Haut droit",
  "vo.layout.bottom-left": "Bas gauche",
  "vo.layout.bottom-right": "Bas droit",
  "vo.layout.split-top": "Moitié haut",
  "vo.layout.split-bottom": "Moitié bas",
  "vo.layout.full": "Plein écran",
  "tool.use": "Utiliser",
  "tool.addHere": "Ici · {t}",
  "tool.style.templates": "Templates",
  "tool.style.looks": "Looks",
  "tool.style.applied": "Style « {name} » appliqué.",
  "tool.captions.show": "Afficher les sous-titres",
  "tool.captions.upper": "Majuscules",
  "captions.style": "Style",
  "captions.lines": "Lignes",
  "captions.lines.hint": "Retape une ligne ; Entrée la coupe, Retour arrière au début la joint à celle d'avant.",
  "captions.lines.none": "Aucune parole sous-titrée dans ce montage.",
  "captions.lines.line": "Ligne à {t}",
  "captions.lines.goto": "Aller à {t}",
  "captions.lines.saved": "Ligne retapée.",
  "captions.lines.split": "Ligne coupée en deux.",
  "captions.lines.joined": "Lignes jointes.",
  "captions.lines.add": "Ajouter une ligne après",
  "captions.lines.addPlaceholder": "La nouvelle ligne",
  "captions.lines.added": "Ligne ajoutée.",
  "captions.lines.remove": "Retirer la ligne",
  "captions.lines.removed": "Ligne retirée des sous-titres.",
  "captions.lines.restore": "Remettre la ligne",
  "captions.lines.restored": "Ligne remise.",
  "captions.lines.reset": "Recaler sur la parole",
  "captions.lines.resetDone": "Ligne recalée sur la parole.",
  "captions.lines.retimed": "Ligne recalée.",
  "captions.retype": "Retaper le sous-titre",
  "common.add": "Ajouter",
  "tool.text.placeholder": "Ton titre",
  "tool.text.add": "Ajouter à {t}",
  "tool.text.addDisabled": "Pas de place",
  "tool.noRoom": "Il n'y a plus de place libre pour ça dans la vidéo : retire ou raccourcis un élément.",
  "tool.text.added": "Titre ajouté à {t}.",
  "tool.elements.text": "Le texte",
  "tool.elements.add": "Ajouter à {t}",
  "tool.elements.added": "{name} ajouté à {t}.",
  "tool.elements.ask": "Ajoute « {name} » ici",
  "tool.elements.animations": "Animations",
  "tool.elements.animationsHint": "Elles se posent tout de suite et reprennent ce que tu dis à cet instant.",
  "tool.elements.blocks": "Blocs",
  "tool.elements.blocksHint": "Les blocs simples se posent avec ton texte. Ceux marqués IA sont demandés à l'IA, qui les prépare avec ton contenu.",
  "tool.elements.aiBadge": "IA",
  "tool.elements.aiBadgeHint": "Préparé par l'IA avec ton contenu",
  "tool.elements.photos": "Il faut {n} photos dans ton projet pour celle-ci.",
  "tool.elements.adapts": "Ses textes reprennent ce que tu dis à cet instant.",
  "tool.elements.asIs": "Elle se pose telle quelle.",
  "tool.elements.adding": "On l'adapte à ta vidéo…",
  "tool.elements.motionAdded": "« {name} » ajouté à {t}, avec tes mots.",
  "tool.elements.motionPartial": "« {name} » ajouté à {t}. Quelques textes restent ceux de l'exemple : demande à l'IA de les changer.",
  "tool.elements.motionSample": "« {name} » ajouté à {t} avec son texte d'exemple : l'IA n'a pas pu l'adapter. Demande-lui de le changer.",
  "tool.elements.motionNoSpeech": "« {name} » ajouté à {t} avec son texte d'exemple : ta vidéo n'a pas de parole à reprendre.",
  "tool.elements.motionLater": "« {name} » ajouté à {t}. Ses textes, repris de ce qui se dit, arrivent…",
  "tool.music.volume": "Volume",
  "tool.music.duck": "Baisser sous la voix",
  "tool.music.fit": "Se termine avec la vidéo",
  "tool.music.fitHint": "Au rendu, la musique est remontée sur ses temps pour que sa fin tombe sur la fin de la vidéo.",
  "tool.music.remove": "Retirer",
  "tool.music.added": "« {name} » ajoutée à {t}",
  "tool.music.mode": "Poser la musique",
  "tool.music.replace": "Remplacer",
  "tool.music.startsAt": "La musique commence à {t}",
  "tool.music.endsAt": "La musique s'arrête à {t}",
  "tool.music.span": "De {from} à {to}",
  "tool.music.spanToEnd": "De {from} jusqu'à la fin",
  "tool.music.startHere": "Commencer ici",
  "tool.music.endHere": "Arrêter ici",
  "tool.music.toEnd": "Jusqu'à la fin",
  "tool.music.set": "Musique : {name}.",
  "tool.music.empty": "Ajoute tes musiques dans la Bibliothèque.",
  "tool.music.free": "Musique libre",
  "tool.sound.import": "Importer",
  "tool.sound.importing": "Envoi · {p} %",
  "tool.sound.importHint": "Ton fichier audio (MP3, M4A, WAV…), gardé dans ta bibliothèque.",
  "tool.music.popular": "Sons populaires",
  "tool.song.current": "Son du montage",
  "tool.song.remove": "Retirer",
  "tool.song.original": "Le son de la vidéo d'origine part dans la vidéo exportée, calé pile sur tes coupes. Choisis un autre son pour le remplacer.",
  "tool.song.explain": "Ce morceau peut partir dans la vidéo exportée, pour un usage personnel uniquement. Pour publier sur Instagram ou TikTok, exporte sans lui et ajoute-le dans l'app, qui en a les droits. Le montage est calé sur son tempo.",
  "tool.song.apple": "Extraits fournis par Apple Music.",
  "tool.song.set": "Son du montage : {name}. À l'export : dans la vidéo (usage personnel) ou à ajouter dans l'app.",
  "tool.song.empty": "Aucun son dans cette catégorie.",
  "tool.song.all": "Tous",
  "tool.song.explicit": "Paroles explicites",
  "tool.song.inUse": "Utilisé",
  "tool.song.search": "Chercher un titre ou un artiste",
  "tool.song.appleAll": "Dans tout Apple Music",
  "tool.song.searching": "Recherche dans Apple Music…",
  "tool.song.none": "Aucun morceau trouvé. Vérifie l'orthographe, ou essaie le nom de l'artiste.",
  "tool.song.noMore": "Rien de plus dans Apple Music.",
  "tool.song.retry": "Réessayer",
  "tool.song.busy": "Beaucoup de recherches en même temps : réessaie dans un instant.",
  "tool.song.down": "La recherche de musiques ne répond pas pour l'instant. Réessaie dans un instant.",
  "tool.sounds.added": "{name} à {t}.",
  "tool.sounds.empty": "Ajoute tes sons dans la Bibliothèque.",

  "ai.retouch": "Retoucher",
  "ai.idea.dynamic": "Plus dynamique",
  "ai.emptyTitle": "Qu'est-ce que tu changerais ?",
  "ai.emptyBody": "Écris-le en bas, dis-le au micro, ou touche l'image à l'endroit qui ne va pas. L'IA s'occupe du reste et crée {v}.",
  "ai.readyOne": "1 retour prêt",
  "ai.readyN": "{n} retours prêts",
  "ai.wholeVideo": "Toute la vidéo",
  "ai.scope.label": "Où l'IA retouche",
  "ai.scope.passage": "Ce passage · {a} → {b}",
  "ai.scope.range": "{a} → {b}",
  "ai.scope.start": "Début du passage",
  "ai.scope.end": "Fin du passage",
  "ai.scope.clips": "{n} plans",
  "ai.scope.clips.one": "{n} plan",
  "ai.scope.texts": "{n} textes",
  "ai.scope.texts.one": "{n} texte",
  "ai.scope.elements": "{n} éléments",
  "ai.scope.elements.one": "{n} élément",
  "ai.scope.sounds": "{n} sons",
  "ai.scope.sounds.one": "{n} son",
  "ai.scope.music": "musique",
  "ai.scope.voice": "voix",
  "ai.placeholderAt": "Enlève cette phrase…",
  "ai.placeholderGlobal": "Ajoute du rythme partout…",
  "ai.notePlaceholder": "Ton retour",
  "ai.voicePlaceholder": "Note vocale (tu peux ajouter un mot)",
  "ai.queue": "Ajouter un autre retour avant d'envoyer",
  "ai.create": "Créer {v}",
  "ai.createN": "Créer {v} · {n} retours",
  "ai.createNone": "Écris un retour pour créer {v}",
  "ai.working": "L'IA travaille…",
  "ai.creating": "L'IA crée {v}",
  "ai.creatingHint": "Tu peux continuer à regarder : la nouvelle version s'ouvrira toute seule.",
  "ai.changesOne": "{v} : 1 changement de l'IA",
  "ai.changesN": "{v} : {n} changements de l'IA",
  "ai.notDone": "{n} pas fait(s)",
  "ai.oldVersion": "Tu regardes {v} : les retours partent sur la dernière.",
  "ai.ask": "Demander",
  "ai.changes": "Changements",
  "ai.transcript": "Texte",
  "ai.placeholder": "Qu'est-ce qu'on change à {t} ?",
  "ai.pin": "Sur l'image",
  "ai.global": "Toute la vidéo",
  "ai.pinHint": "Touche l'image là où ça ne va pas.",

  "versions.title": "Versions",
  "versions.latest": "la dernière",
  "versions.compare": "Comparer",
  "versions.restore": "Revenir à {v}",

  "export.captions": "Sous-titres",
  "export.share": "Partager",

  "insp.templates": "Templates",
  "insp.captions": "Sous-titres",
  "insp.music": "Musique",
  "insp.categories": "Catégories",
  "insp.all": "Tout",
  "platform.tiktok": "TikTok",
  "platform.reels": "Reels",
  "platform.shorts": "Shorts",
  "platform.youtube": "YouTube",
  "platform.other": "Autres",
  "platform.choose": "Pour où ?",
  "platform.otherFormats": "Ou choisis un format",
  "vibe.dynamique": "Dynamique",
  "vibe.pedagogique": "Pédagogique",
  "vibe.narratif": "Récit",
  "vibe.pose": "Posé",
  "insp.grid": "Grille",
  "insp.feed": "Plein écran",
  "insp.use": "Utiliser",
  "insp.favorite": "Favori",
  "insp.none": "Rien dans cette catégorie pour l'instant.",
  "insp.musicSoon": "Les musiques libres arrivent bientôt.",
  "insp.rhythm": "Calés sur la musique",
  "insp.rhythmHint": "Musique, rythme et transitions prêts : ajoute tes plans.",
  "insp.rhythmBadge": "Calé sur la musique",
  "insp.onBeat": "calé sur le rythme",
  "insp.noSpeech": "sans parole",
  "insp.freeMusic": "Musique libre",
  "insp.appleMusic": "Écouter sur Apple Music",
  "insp.songToAdd": "à ajouter dans Instagram ou TikTok",
  "insp.soundOn": "Remettre le son",
  "insp.soundOff": "Couper le son",

  "lib.all": "Tout",
  "lib.favoris": "Favoris",
  "lib.templates": "Mes templates",
  "lib.musique": "Musique",
  "lib.sons": "Sons",
  "lib.rushes": "Rushes réutilisables",
  "lib.kits": "Kits",
  "lib.add": "Ajouter",
  "lib.remove": "Supprimer",
  "lib.create": "Créer",
  "lib.analyzing": "Analyse…",
  "lib.failed": "Pas abouti",
  "lib.favEmpty": "Touche le cœur d'un template, d'un style ou d'une musique.",
  "lib.musicEmpty": "Aucune musique.",
  "lib.sfxEmpty": "Aucun son.",
  "lib.free": "Libres de droits",
  "lib.rushesEmpty": "Intro, outro, plans signature : ce que tu réutilises.",
  "lib.fromPrompt": "Décris ton style",
  "lib.fromVideo": "Depuis une vidéo d'inspiration",
  "lib.promptPlaceholder": "Vlog voyage, rythme rapide, sous-titres jaunes…",
  "lib.compose": "Créer le template",
  "lib.composing": "Je compose…",
  "lib.pickVideo": "Choisir la vidéo",
  "lib.sendingVideo": "Envoi de la vidéo…",
  "lib.fromLink": "Coller un lien (TikTok, Instagram, YouTube…)",
  "lib.linkPlaceholder": "https://www.tiktok.com/@…/video/…",
  "lib.analyze": "Analyser la vidéo",
  "lib.fetching": "Je récupère la vidéo…",
  "lib.modeTitle": "Qu'est-ce que j'en garde ?",
  "lib.mode.inspiration": "Inspiration",
  "lib.mode.inspirationHint": "Je comprends comment elle marche : genre, ambiance, architecture, procédés. Tes montages auront la même âme, pas le même contenu ni forcément la même musique.",
  "lib.mode.replica": "Modèle",
  "lib.mode.replicaHint": "Je la reproduis plan par plan avec tes rushs : durées, textes et leurs animations, transitions, musique.",
  "insp.fromLink": "Depuis un lien",
  "ref.use": "Utiliser ce template",
  "tpl.preview.more": "Plus",
  "tpl.preview.source": "Voir la vidéo d'origine",
  "tpl.preview.share": "Partager le template",
  "tpl.preview.copied": "Lien copié : qui l'ouvre reçoit ce template.",
  "tpl.preview.mute": "Couper le son",
  "tpl.preview.unmute": "Remettre le son",
  "tpl.shared.app": "Ouvrir dans l'app iPhone",
  "tpl.shared.library": "Voir mes templates",
  "kind.lib.logo": "Logo",
  "kind.lib.image": "Image",
  "kind.lib.screen": "Écran",
  "kind.lib.broll": "Plan de coupe",
  "kind.lib.footage": "Rush",
  "kind.lib.music": "Musique",
  "kind.lib.sfx": "Son",

  "kit.untitled": "Mon kit",
  "kit.new": "Nouveau kit",
  "kit.remove.title": "Supprimer « {name} » ?",
  "kit.remove.body": "Ce kit ne sera plus proposé pour tes montages.",
  "kit.default": "par défaut",
  "kit.saveFirst": "Enregistre le kit avant d'ajouter son logo.",
  "kit.part.identity": "Identité",
  "kit.part.colors": "Couleurs",
  "kit.part.captions": "Sous-titres",
  "kit.part.end": "Fin",

  // Doc 14 : la création en six écrans.
  "create.title": "Nouveau montage",
  "create.starting": "Je prépare ton montage…",
  "create.steps": "Étapes de création",
  "create.stepOf": "Étape {n} sur {total}",
  "create.goStep": "Aller à l’étape {n} : {name}",
  "create.continue": "Continuer",
  "create.working": "Un instant…",
  "create.yes": "Oui",
  "create.no": "Non",
  "create.conflict": "Ce montage a été modifié sur un autre écran. Recharge pour reprendre la dernière version.",
  "create.saveFailed": "Je n'arrive pas à enregistrer tes derniers choix. Ils restent sur cet appareil ; je réessaie au prochain changement.",
  "create.step.plans": "Plans",
  "create.step.montage": "Montage",
  "create.h.plans": "Dépose tes plans",
  "create.h.montage": "Ton montage",
  "create.plans.lead": "Les vidéos où tu parles, tes plans de coupe, captures d’écran et images. Chaque plan est regardé dès son arrivée : vérifie ce que l’IA y voit et corrige si besoin.",
  "create.tags.title": "Ce que l’IA voit dans tes plans",
  "create.tags.voice": "Ta voix est gardée dès qu’on t’entend, quoi que montre le plan (toi, un écran que tu commentes…). Décris ce qu’on y voit et ce que tu y dis : le monteur s’en sert pour l’ordre et le sens.",
  "create.tags.waiting": "Je regarde ce plan…",
  "create.tags.none": "Pas encore regardé : il le sera au montage.",
  "create.tags.kind": "On y voit",
  "create.tags.kind.parole": "Moi face caméra",
  "create.tags.kind.plan": "Plan de coupe",
  "create.tags.kind.ecran": "Un écran",
  "create.tags.kind.image": "Image",
  "site.title": "Pas de vidéo ? Pars de ton site",
  "site.lead": "Donne l’adresse de ton site : je récupère ton logo, tes couleurs et tes photos, je complète avec des photos libres de droits, et j’en fais une vidéo animée à ton image.",
  "site.url": "Adresse de ton site",
  "site.placeholder": "https://ta-boulangerie.fr",
  "site.read": "Lire mon site",
  "site.reread": "Relire",
  "site.reading": "Lecture…",
  "site.progress": "Je lis ton site, je récupère ton logo et tes photos… (une minute environ)",
  "site.brand": "Ta marque",
  "site.logo": "Ton logo",
  "site.logoKept": "Logo gardé dans tes plans",
  "site.noLogo": "Pas de logo trouvé : ajoute-le en image si tu veux qu’il apparaisse.",
  "site.colors": "Tes couleurs",
  "site.color.accent": "Couleur forte",
  "site.color.bg": "Fond",
  "site.color.text": "Texte",
  "site.font": "Police : {font}",
  "site.name": "Nom affiché",
  "site.tagline": "Accroche (à l’ouverture)",
  "site.cta": "Appel à l’action (carte de fin)",
  "site.ctaHint": "Ex. : Passez nous voir",
  "site.contact": "Où te trouver (carte de fin)",
  "site.contactLine": "Ligne {n}",
  "site.facts": "Ce que la vidéo peut dire de toi",
  "site.style": "Style de la vidéo",
  "site.music": "Musique",
  "site.noMusic": "Sans musique",
  "site.musicChosen": "Musique proposée",
  "site.how": "Ta vidéo s’ouvrira sur ton logo, montrera tes photos animées avec quelques phrases, et finira sur ton appel à l’action. En « Auto », l’IA regarde ton site et invente les animations qui lui ressemblent.",
  "site.forget": "Ne pas partir du site",
  "site.free": "Photo libre de droits",
  "create.tags.summary": "Ce qu’on y voit",
  "create.tags.keywords": "Mots-clés (séparés par des virgules)",
  "create.tags.save": "Enregistrer",
  "create.tags.saved": "Corrigé par toi",
  "create.tags.byAi": "Vu par l’IA",
  "create.tags.exclude": "Ne pas utiliser",
  "create.tags.include": "Utiliser",
  "create.tags.excluded": "Pas utilisé dans ce montage",
  "create.montage.brief": "Ce que la vidéo doit dire (facultatif)",
  "create.montage.briefHint": "Ex. : « J’annonce que je quitte ma startup et j’explique mon plan pour 3 mois. Garde le ton sincère. »",
  "create.montage.duration": "Durée visée en secondes (facultatif)",
  "create.montage.model": "Monteur IA",
  "create.montage.modelHint": "Même consignes pour les deux : seul le modèle change, pour comparer.",
  "create.montage.base": "Le montage garde ta voix, retire les reprises et les blancs, pose tes plans de coupe au bon moment et ajoute les sous-titres. Pas de musique ni d’effets pour l’instant.",
  "create.montage.rhythm": "Template « {name} » : sans parole, tous tes plans sont coupés sur le temps de la musique, avec ses transitions.",
  "create.montage.template": "Template « {name} » : le montage suit sa structure et son style.",
  "create.step.drop": "Éléments",
  "create.step.external": "Sites",
  "create.step.order": "Ordre",
  "create.step.describe": "Intention",
  "create.step.setup": "Réglages",
  "create.step.launch": "Lancement",
  "create.h.drop": "Dépose tes éléments",
  "create.h.external": "Des éléments à aller chercher ?",
  "create.h.order": "Vérifie tes plans et leur ordre",
  "create.h.describe": "Décris ton montage",
  "create.h.setup": "Les réglages",
  "create.h.launch": "Choisis le niveau et lance",
  "create.drop.empty": "Ajoute au moins un fichier pour continuer.",
  "create.drop.sending": "Les envois continuent : tu peux avancer, le montage attendra qu’ils soient finis.",
  "create.setup.format": "Format",
  "create.setup.noTemplate": "Aucun template",
  "create.setup.dynamism": "Dynamisme",
  "create.dyn.simple": "Simple",
  "create.dyn.simple.hint": "Des coupes discrètes, sans zoom ni effet.",
  "create.dyn.moyen": "Moyen",
  "create.dyn.moyen.hint": "Des coupes et des zooms, sans transitions décoratives.",
  "create.dyn.eleve": "Élevé",
  "create.dyn.eleve.hint": "Zooms, transitions et accents là où ils servent.",
  "create.launch.tier": "Niveau",
  "create.tier.normal": "Normal",
  "create.tier.eleve": "Élevé",
  "create.tier.available": "Disponible",
  "create.tier.why.no_key": "Pas encore ouvert sur ton compte",
  "create.tier.why.unknown_model": "Indisponible pour le moment",
  "create.tier.why.key_refused": "Indisponible pour le moment",
  "create.tier.why.no_price": "Pas encore ouvert : son coût reste à vérifier",
  "create.tier.why.unreachable": "Indisponible pour le moment, réessaie un peu plus tard",
  "create.tier.why.agent_off": "Indisponible pour le moment",
  "create.tier.whyLine": "{tier} : {why}",
  "create.launch.tierBlocked": "Ce niveau est indisponible : choisis-en un autre.",
  "create.sum.assets": "Éléments",
  "create.sum.sources": "Sources",
  "create.sum.brief": "Description",
  "create.sum.none": "Aucune",
  "create.launch.estimate": "Environ {min} à {max} min, démarrage compris. Coût IA estimé : {lo} à {hi} $.",
  "create.launch.go": "Créer ma V1",
  "flow.next": "Suivant",
  "flow.skip": "Passer",
  "flow.back": "Retour",
  "flow.close": "Fermer",
  "flow.stepOf": "{n}/{total}",
  "flow.watch": "Je regarde {seen}/{total}",
  "flow.watched": "{n} plans vus",
  "flow.watched.one": "{n} plan vu",
  "flow.watchLater": "Je regarderai au montage",
  "flow.quoi.title": "On fait quoi ?",
  "flow.quoi.lead": "Choisis, le reste suit.",
  "flow.quoi.video": "Une vidéo",
  "flow.quoi.videoHint": "Tes rushs, montés autour de ta voix.",
  "flow.quoi.carousel": "Un carrousel",
  "flow.quoi.carouselHint": "Des images qui défilent, pour un fil.",
  "flow.quoi.site": "Depuis mon site",
  "flow.quoi.siteHint": "Pas de rushs ? Ton logo, tes photos, tes couleurs.",
  "flow.plans.title": "Tes plans",
  "flow.plans.lead": "Prends tout ce qui peut servir. Je commence à regarder tout de suite.",
  "flow.plans.add": "Ajouter",
  "flow.plans.library": "Bibliothèque",
  "flow.plans.site": "Mon site",
  "flow.plans.drop": "Dépose des fichiers n'importe où sur la page",
  "flow.plans.sending": "Envoi en cours…",
  "flow.plans.empty": "Dépose tes vidéos : celles où tu parles, tes plans de coupe, tes captures d'écran.",
  "flow.plans.count0": "Aucun plan choisi",
  "flow.plans.count1": "1 plan choisi",
  "flow.plans.count": "{n} plans choisis",
  "flow.kind.parole": "Parole",
  "flow.kind.plan": "Plan",
  "flow.kind.ecran": "Écran",
  "flow.kind.image": "Image",
  "flow.format.title": "Pour où ?",
  "flow.format.lead": "Le format de ta vidéo. Tu pourras changer plus tard.",
  "flow.format.use.vertical-talking-head": "Reels · TikTok",
  "flow.format.use.vertical-split-card": "Face cam + écran",
  "flow.format.use.landscape-youtube": "YouTube",
  "flow.format.use.square-feed": "Fil carré",
  "flow.format.use.portrait-feed": "Fil portrait",
  "flow.style.title": "Un style ?",
  "flow.style.lead": "Facultatif. Sans rien, le monteur décide.",
  "flow.style.none": "Le monteur décide",
  "flow.style.noneHint": "Il s'appuie sur tes plans et ta voix.",
  "flow.style.template": "Un template",
  "flow.style.mine": "Mes templates",
  "flow.style.modeReplica": "Modèle",
  "flow.style.modeInspiration": "Inspiration",
  "flow.style.ref": "Un de mes montages, en référence",
  "flow.brief.title": "Elle doit dire quoi ?",
  "flow.brief.lead": "Facultatif. Une phrase suffit.",
  "flow.brief.placeholder": "Ex. : J'annonce que je quitte ma startup et j'explique mon plan pour 3 mois.",
  "flow.brief.sugg.annonce": "Une annonce",
  "flow.brief.sugg.demo": "Une démo",
  "flow.brief.sugg.temoignage": "Un témoignage",
  "flow.brief.sugg.coulisses": "Des coulisses",
  "flow.brief.text.annonce": "J'annonce une nouvelle importante et j'explique ce qui change pour toi.",
  "flow.brief.text.demo": "Je montre comment ça marche, étape par étape, en gardant la démo écran.",
  "flow.brief.text.temoignage": "Je raconte ce que j'ai vécu, honnêtement, sans effet.",
  "flow.brief.text.coulisses": "Une journée avec moi : les moments vrais, le rythme reste naturel.",
  "flow.reglages.title": "Les réglages",
  "flow.reglages.lead": "Durée, sous-titres, musique, mouvement.",
  "flow.reglages.auto": "Auto",
  "flow.reglages.autoHint": "Le monteur garde l'essentiel, sous-titre, dose le mouvement.",
  "flow.reglages.custom": "Je personnalise",
  "flow.reglages.customHint": "Quatre questions rapides.",
  "flow.duree.title": "Combien de temps ?",
  "flow.duree.lead": "En « Auto », je garde l'essentiel.",
  "flow.duree.auto": "Auto",
  "flow.duree.sec": "sec",
  "flow.duree.min": "min",
  "flow.soustitres.title": "Des sous-titres ?",
  "flow.caps.title": "Des sous-titres ?",
  "flow.caps.lead": "Les mots s'affichent au rythme de ta voix.",
  "flow.caps.yes": "Oui",
  "flow.caps.yesHint": "Lisible sans le son, comme sur un fil.",
  "flow.caps.no": "Non",
  "flow.caps.noHint": "L'image seule.",
  "flow.musique.title": "Une musique ?",
  "flow.music.title": "Une musique ?",
  "flow.music.lead": "Toujours sous ta voix, jamais par-dessus.",
  "flow.music.no": "Non",
  "flow.music.noHint": "Ta voix et le son d'ambiance.",
  "flow.music.yes": "Oui, discrète",
  "flow.music.yesAuto": "Le monteur choisit le titre et le cale sur tes coupes.",
  "flow.music.yesMood": "Le monteur choisit un titre {mood}.",
  "flow.music.moods": "Ambiance",
  "flow.music.any": "Au choix",
  "flow.music.pick": "Ou choisis un titre",
  "flow.music.pickHint": "{n} titres libres de droits, calés sur le tempo.",
  "flow.music.change": "Changer",
  "flow.music.sheet": "Musique",
  "flow.music.search": "Titre, ambiance, instrument…",
  "flow.music.all": "Tous",
  "flow.music.none": "Rien pour « {q} ». Essaie une ambiance ou un instrument.",
  "flow.music.use": "Utiliser « {title} »",
  "flow.music.listen": "Écouter",
  "flow.music.pause": "Pause",
  "flow.motion.title": "Du mouvement ?",
  "flow.motion.lead": "Zooms, transitions, accents : à quelle dose.",
  "flow.motion.simple": "Sobre",
  "flow.motion.moyen": "Moyen",
  "flow.motion.eleve": "Beaucoup",
  "flow.vu.title": "Voilà ce que j'ai vu",
  "flow.vu.lead": "Corrige-moi si je me trompe. Ça guide le montage.",
  "flow.vu.remaining": "Encore {n} plans à regarder… tu peux déjà corriger.",
  "flow.vu.remaining.one": "Encore {n} plan à regarder… tu peux déjà corriger.",
  "flow.vu.timeout": "Je n'ai pas fini de regarder tes plans. Ce n'est pas grave : le montage les regardera au lancement, tu peux continuer.",
  "flow.vu.waiting": "Je regarde encore tes plans. Tu peux continuer, je te dirai.",
  "flow.vu.ok": "Tout est bon",
  "flow.vu.edit": "Corriger la description",
  "flow.vu.save": "Enregistrer",
  "flow.vu.cancel": "Annuler",
  "flow.pret.title": "Prêt à monter",
  "flow.pret.plans": "{n} plans",
  "flow.pret.plans.one": "{n} plan",
  "flow.pret.template": "template {name}",
  "flow.pret.ref": "comme un de mes montages",
  "flow.opt.title": "Si tu veux (facultatif)",
  "flow.opt.fromTemplate": "Réglé comme le template « {name} » : touche une ligne pour changer.",
  "flow.opt.style": "Style",
  "flow.opt.brief": "Ce qu'elle doit dire",
  "flow.opt.briefNone": "Le monteur trouve l'angle dans tes plans",
  "flow.opt.duree": "Durée",
  "flow.opt.soustitres": "Sous-titres",
  "flow.opt.musique": "Musique",
  "flow.opt.motion": "Mouvement",
  "flow.opt.vu": "Ce que j'ai vu dans tes plans",
  "flow.opt.vuPending": "Je regarde encore",
  "flow.opt.auto": "Auto",
  "flow.opt.yes": "Oui",
  "flow.opt.no": "Non",
  "flow.pret.auto": "réglages auto",
  "flow.pret.durAuto": "durée auto",
  "flow.pret.caps": "sous-titres",
  "flow.pret.noCaps": "sans sous-titres",
  "flow.pret.music": "musique {mood}",
  "flow.pret.noMusic": "sans musique",
  "flow.pret.motion": "mouvement {level}",
  "flow.pret.normalHint": "Rapide et économique",
  "flow.pret.eleveHint": "Le monteur Claude reprend tout le montage",
  "flow.pret.bgUpload": "Tes plans finissent de monter pendant le montage : garde cet onglet ouvert.",
  "flow.pret.estimate": "{lo} – {hi} $ · {min} à {max} min",
  "studio.platform.tiktok": "TikTok",
  "studio.platform.instagram": "Instagram",
  "studio.platform.youtube": "YouTube",
  "studio.stats.likes": "j'aime",
  "studio.adapt.lever": "Ce qui la fait marcher",
  "studio.adapt.hook": "Accroche : {x}",
  "studio.adapt.peak": "Moment fort : {x}",
  "studio.adapt.cta": "Appel : {x}",
  "studio.adapt.keep": "À garder",
  "studio.adapt.change": "À changer pour que ce soit à toi",
  "nav.ideas": "Idées",
  "nav.settings": "Réglages",
  "workspace.title": "Espaces",
  "workspace.label": "Espace : {name}. Changer d'espace",
  "workspace.fallback": "Mon espace",
  "workspace.new": "Nouvel espace…",
  "workspace.rename": "Renommer cet espace…",
  "workspace.account": "Mon compte",
  "workspace.new.title": "Nouvel espace",
  "workspace.new.hint": "Un espace par marque : ses vidéos, ses templates, ses comptes et son analyse restent à part.",
  "workspace.rename.title": "Renommer l'espace",
  "workspace.placeholder": "Nom de la marque",
  "workspace.create": "Créer",
  "settings.app": "App",
  "settings.styles": "Styles",
  "ideas.subEmpty": "Dis-nous ce que tu fais pour des idées sur mesure",
  "ideas.origin.own": "Ton idée",
  "ideas.origin.adapted": "D'après une vidéo de @{author}",
  "ideas.origin.adaptedAnon": "D'après une vidéo qui marche",
  "ideas.origin.suggested": "Pour toi",
  "ideas.why": "Pourquoi :",
  "ideas.explain": "Chaque idée part d'une vidéo qui a vraiment marché : {from}. Mise à jour chaque jour.",
  "ideas.from.mine": "tes vidéos",
  "ideas.from.followed": "les comptes que tu suis",
  "ideas.from.niche": "ta niche",
  "ideas.from.about": "ce que tu fais",
  "ideas.hot": "Ce qui cartonne en ce moment",
  "ideas.hot.niche": "ta niche",
  "ideas.hot.followed": "compte suivi",
  "ideas.trends": "Tendances de la semaine",
  "ideas.trend.creators": "{n} créateurs",
  "ideas.trend.lead": "Ce mot-dièse revient chez {n} créateurs qui cartonnent en ce moment, jusqu'à {best} leurs vues habituelles.",
  "ideas.trend.rising": "Ça accélère.",
  "ideas.trend.ideas": "Voir les idées sur les tendances",
  "ideas.filter.all": "Tout",
  "ideas.filter.mine": "Chez moi",
  "ideas.filter.others": "Chez les autres",
  "ideas.filter.trends": "Tendances",
  "ideas.origin.mine": "Encore chez toi",
  "ideas.origin.others": "Chez les autres",
  "ideas.origin.trend": "Tendance",
  "ideas.origin.playbook": "Méthode des meilleurs",
  "ideas.potential.strong": "Fort potentiel",
  "ideas.potential.good": "Bon potentiel",
  "ideas.potential.test": "À tester",
  "ideas.learned": "Ce qui marche chez toi",
  "ideas.alerts": "À ne pas rater",
  "ideas.alerts.lead": "Ce que la veille a repéré ces derniers jours.",
  "ideas.asked.many": "{n} personnes ont demandé : « {q} »",
  "ideas.asked.one": "Une question en commentaire : « {q} »",
  "ideas.questions": "Ton public demande",
  "ideas.questions.lead": "Les questions qui reviennent sous tes vidéos, sur 30 jours.",
  "ideas.questions.count": "{n} fois",
  "ideas.questions.on": "sous « {title} »",
  "ideas.retention": "Où les gens partent",
  "ideas.retention.lead": "La courbe de YouTube, rapportée à ton montage quand la vidéo en vient.",
  "ideas.retention.better": "retient mieux que les vidéos de même durée",
  "ideas.retention.worse": "retient moins bien que les vidéos de même durée",
  "ideas.retention.steady": "pas de chute nette",
  "ideas.openings": "Tes premières secondes",
  "ideas.openings.lead": "Ce qu'on voit au début de tes vidéos : tes réussites contre tes plus faibles.",
  "ideas.openings.waiting": "{n} vidéos regardées : pas encore de différence nette entre tes réussites et les autres.",
  "ideas.remix": "Refais ce succès",
  "ideas.remix.lead": "Ces vidéos ont marché : une variante retouchée, ou la suite, plutôt qu'une republication à l'identique.",
  "ideas.remix.hook": "Nouvelle accroche",
  "ideas.remix.shorter": "Plus court",
  "ideas.remix.elsewhere": "Sur {name}",
  "ideas.remix.followup": "La suite",
  "ideas.remix.multiple": "{x} tes vues habituelles",
  "ideas.remix.variants": "Variantes : {list}",
  "ideas.remix.pending": "pas encore publiée",
  "ideas.remix.started": "La variante se monte : tu la retrouves dans Vidéos.",
  "ideas.remix.failed": "La variante n'a pas pu partir. Réessaie dans un instant.",
  "ideas.learned.lead": "Mesuré sur tes vidéos venues d'une idée, une fois publiées.",
  "ideas.learned.row": "{name} : {x} tes vues habituelles ({n} vidéos)",
  "ideas.learned.strong": "Idées « fort potentiel » : {hits} sur {n} ont dépassé 2×",
  "ideas.learned.outcome": "{x} tes vues habituelles",
  "ideas.learned.waiting": "En attente des chiffres",
  "ideas.learned.unpublished": "Pas encore publiée",
  "ideas.learned.predicted": "annoncée : {level}",
  "ideas.learned.empty": "Monte une idée et publie-la : son résultat apparaîtra ici.",
  "ideas.family.mine": "Tes réussites",
  "ideas.family.others": "Les méthodes des autres",
  "ideas.family.trend": "Les tendances",
  "ideas.structure.suspense": "Suspense",
  "ideas.structure.quick_value": "Astuce rapide",
  "ideas.structure.story": "Histoire",
  "ideas.structure.contrarian": "Contre-pied",
  "ideas.structure.step_by_step": "Pas à pas",
  "ideas.structure.versus": "Comparaison",
  "ideas.structure.rapid_fire": "En rafale",
  "ideas.dismiss": "Pas pour moi",
  "ideas.filterEmpty": "Rien ici pour l'instant : demande d'autres idées.",
  "ideas.evidenceOpen": "Voir la vidéo qui a marché",
  "ideas.base.mine": "tes vues habituelles",
  "ideas.base.niche": "les vues habituelles de ta niche",
  "ideas.base.others": "ses vues habituelles",
  "ideas.playbook.many": "La méthode de {n} comptes que tu suis, dans leurs meilleures vidéos",
  "ideas.playbook.one": "Une méthode des meilleures vidéos des comptes que tu suis",
  "ideas.lookingHits": "On regarde ce qui marche chez toi et chez les autres…",
  "ideas.emptyLead": "Tes idées partent de ce qui marche : tes vidéos, les comptes que tu suis, ta niche.",
  "ideas.moreFromHits": "D'autres idées",
  "ideas.script": "Script",
  "ideas.read": "Lire le script",
  "ideas.make": "Monter",
  "ideas.remove": "Retirer cette idée",
  "ideas.prev": "Idée précédente",
  "ideas.next": "Idée suivante",
  "ideas.page": "Idée {n} sur {total}",
  "ideas.more.title": "Aucune ne te parle ?",
  "ideas.more.go": "D'autres idées",
  "ideas.more.busy": "Je cherche…",
  "ideas.own": "Une idée à moi",
  "ideas.paste": "Coller une vidéo qui marche",
  "ideas.first": "Monte ta première vidéo : on te proposera la suivante.",
  "ideas.create": "Créer une vidéo",
  "ideas.searching": "Je cherche tes prochaines idées…",
  "ideas.fromVideos": "Tes prochaines idées partent de tes vidéos.",
  "ideas.find": "Trouver des idées",
  "ideas.unavailable": "Les idées reviennent dans un instant.",
  "ideas.seconds": "{s} s",
  "ideas.reused.one": "{n} plan déjà filmé",
  "ideas.reused": "{n} plans déjà filmés",
  "ideas.shape.talking": "face caméra",
  "ideas.shape.split": "face caméra + écran",
  "ideas.shape.landscape": "à l'horizontale",
  "ideas.shape.square": "carrée",
  "ideas.shape.portrait": "portrait",
  "ideas.about.title": "Tu fais quoi ?",
  "ideas.about.lead": "En une phrase. Tes idées de vidéos partiront de là.",
  "ideas.about.placeholder": "Coach, artisan, créatrice…",
  "ideas.about.continue": "Continuer",
  "ideas.about.skip": "Passer",
  "ideas.script.title": "Le script",
  "ideas.script.say": "{s} s à dire",
  "ideas.script.shoot": "À tourner",
  "ideas.script.make": "Monter avec ce script",
  "ideas.script.prompter": "Me filmer avec le prompteur",
  "ideas.script.another": "Un autre script",
  "ideas.script.writing": "J'écris ton script…",
  "ideas.script.later": "Le script revient dans un instant.",
  "script.title": "Le script",
  "script.write": "Écrire le script",
  "script.start.title": "De quoi parle ta vidéo ?",
  "script.start.lead": "Une phrase suffit. On cherche à qui tu parles, on écrit plusieurs accroches, on garde la meilleure, puis on écrit et on relit le script à voix haute.",
  "script.start.placeholder": "Ex. : taper droit au premier départ quand on débute",
  "script.start.topic": "Je pars d'un sujet",
  "script.start.draft": "J'ai déjà un brouillon",
  "script.start.draftPlaceholder": "Colle ton texte : on le relit à voix haute et on le resserre.",
  "script.start.duration": "Durée visée",
  "script.start.seconds": "{s} s",
  "script.start.go": "Écrire le script",
  "script.stage.frame": "Je cherche à qui tu parles…",
  "script.stage.hooks": "J'écris des accroches…",
  "script.stage.audit": "Je garde les meilleures…",
  "script.stage.body": "J'écris le script…",
  "script.stage.revise": "Je le relis à voix haute…",
  "script.stage.shots": "Je prépare le plan de tournage…",
  "script.writingHint": "Tu peux quitter cet écran : le script continue de s'écrire.",
  "script.question": "Une question avant d'écrire",
  "script.answer": "Répondre",
  "script.answerPlaceholder": "Ta réponse, avec tes mots",
  "script.hooks": "Accroches proposées",
  "script.hookUse": "Ouvrir sur cette accroche",
  "script.hookChosen": "Choisie",
  "script.hookLabel": "Accroche",
  "script.say": "{s} s à dire",
  "script.hard": "Dure à dire",
  "script.notes.delivery": "Ton et débit",
  "script.notes.screen": "À l'écran",
  "script.notes.sound": "Le son",
  "script.changes": "Ce que la relecture a changé",
  "script.issues": "À reprendre",
  "script.revise": "Relire et resserrer",
  "script.reviseNote": "Une remarque ? (facultatif)",
  "script.reviseGo": "Relire",
  "script.shots": "Plan de tournage",
  "script.shotsGo": "Préparer le plan de tournage",
  "script.shot.have": "Déjà filmé",
  "script.shot.film": "À tourner",
  "script.shot.match": "Raccord : {x}",
  "script.shot.emotion": "émotion",
  "script.shot.information": "information",
  "script.shot.type.over_shoulder": "Par-dessus l'épaule",
  "script.shot.type.extreme_close": "Très gros plan",
  "script.shot.type.wide": "Plan large",
  "script.shot.type.medium": "Plan moyen",
  "script.shot.type.close": "Gros plan",
  "script.shot.type.high_angle": "Plongée",
  "script.shot.type.pov": "Vue subjective",
  "script.shot.type.wide_angle_close": "Grand-angle de près",
  "script.prompter": "Prompteur",
  "script.film": "Filmer et monter",
  "script.edit": "Retoucher le texte",
  "script.editHint": "Une phrase par ligne. Les premières restent l'accroche.",
  "script.failed.other": "Le script n'a pas pu s'écrire. Réessaie : on reprend là où on s'était arrêté.",
  "script.failed.budget": "L'écriture de scripts est en pause pour l'instant. Réessaie plus tard.",
  "script.failed.pending": "Une écriture identique est déjà en cours : réessaie dans un instant.",
  "script.none": "Pas encore de script pour cette vidéo.",
  "script.forVideo": "Le script de ta vidéo",
  "script.starting": "On prépare ton script…",
  "flow.quoi.script": "Écrire le script",
  "flow.quoi.scriptHint": "Avant de filmer : accroches, script relu, plan de tournage",
  "ideas.prompter.play": "Lancer",
  "ideas.prompter.pause": "Pause",
  "ideas.ownSheet.title": "Ton idée en une phrase",
  "ideas.ownSheet.placeholder": "Ex. : les trois erreurs que je vois chaque samedi",
  "ideas.ownSheet.add": "Ajouter",
  "ideas.paste.title": "Une vidéo qui marche",
  "ideas.paste.lead": "Colle le lien d'une vidéo qui a marché, la tienne ou celle d'un autre : on trouve ce qui la fait marcher et on en fait une idée pour toi.",
  "ideas.paste.placeholder": "Lien TikTok, Instagram ou YouTube",
  "ideas.paste.go": "Voir ce qui la fait marcher",
  "ideas.paste.reading": "Je regarde la vidéo et j'écoute ce qui s'y dit…",
  "ideas.paste.soon": "Lire un lien arrive bientôt.",
  "ideas.paste.failed": "On ne peut pas lire cette vidéo pour l'instant. Réessaie dans un instant.",
  "ideas.paste.views": "{n} vues",
  "ideas.paste.lever": "Ce qui la fait marcher",
  "ideas.paste.yours": "Ta version",
  "ideas.paste.detail": "Voir le détail",
  "ideas.paste.keep": "À garder",
  "ideas.paste.change": "À changer pour que ce soit à toi",
  "videos.next": "Ta prochaine vidéo",
  "videos.next.make": "La monter",
  "videos.next.hide": "Masquer cette idée",
  "videos.shelf.inProgress": "En cours",
  "videos.shelf.ready": "Prêtes",
  "videos.shelf.draft": "Brouillons",
  "videos.status.working": "Montage en cours",
  "videos.status.published": "Publiée",
  "videos.status.publishedViews": "Publiée · {views}",
  "videos.views.one": "{n} vue",
  "videos.views": "{n} vues",
  "videos.empty.title": "Ta première vidéo en 3 gestes.",
  "videos.empty.lead": "Choisis tes plans, on monte autour de ta voix.",
  "videos.empty.step1": "Choisis tes plans",
  "videos.empty.step1.hint": "Les vidéos où tu parles, et quelques images autour.",
  "videos.empty.step2": "On monte ta vidéo",
  "videos.empty.step2.hint": "Coupes, sous-titres et musique, en quelques minutes.",
  "videos.empty.step3": "Tu relis et tu publies",
  "videos.empty.step3.hint": "Un mot à changer ? Tu le demandes, c'est refait.",
  "videos.empty.cta": "Choisir mes plans",
  "videos.empty.styles": "Essayer un style",
  "ready.more": "Plus d'options",
  "ready.plans": "Mes plans",
  "ready.publish": "Enregistrer et publier",
  "ready.edit": "Modifier",
  "ready.ask": "Demander un changement",
  "ready.before": "Avant de publier",
  "ready.fix": "Corriger pour moi",
  "ready.allGood": "Rien à corriger : elle est prête à partir.",
  "ready.how": "Comment elle marche",
  "ready.viewsWord.one": "vue",
  "ready.viewsWord": "vues",
  "ready.savesWord.one": "enregistrement",
  "ready.savesWord": "enregistrements",
  "ready.usual": "tes vues habituelles",
  "ready.statsSoon": "Ses chiffres arrivent : reviens dans un moment.",
  "ready.seePost": "Voir la vidéo publiée",
  "ready.already": "Déjà publiée ?",
  "ready.alreadyLead": "Colle son lien : tu verras ici combien de personnes l'ont regardée.",
  "ready.saved": "Lien gardé.",
  "ready.savedViews.one": "Lien gardé : {n} vue pour l'instant.",
  "ready.savedViews": "Lien gardé : {n} vues pour l'instant.",
  "ready.open": "Voir ses chiffres",
  "advice.hook_none": "Ouvre sur une phrase qui donne envie de rester.",
  "advice.hook_slow": "Ta première phrase arrive tard : commence plus vite.",
  "advice.cta_none": "Termine par une demande : t'abonner, commenter, essayer.",
  "advice.captions_off": "Ajoute des sous-titres : beaucoup regardent sans le son.",
  "advice.duration_long": "Elle est longue pour ce réseau : garde l'essentiel.",
  "advice.rhythm_static": "Un passage reste longtemps sur le même plan : coupe-le.",
  "advice.speech_dense": "Tu parles vite : laisse respirer une ou deux phrases.",
  "advice.speech_slow": "Il y a des blancs : resserre les silences.",
  "advice.duration_short": "Elle est très courte : une phrase de plus l'aiderait.",
  "advice.overlays_heavy": "Beaucoup de textes à l'écran : allège.",
  "advice.music_none": "Une musique discrète porterait la vidéo.",
  "content.title": "Ton contenu",
  "content.foot": "Tes idées de vidéos partent d'ici.",
  "content.about": "Ce que tu fais",
  "content.toSay": "À dire",
  "content.aboutLine": "En une phrase",
  "content.aboutHint": "Ce que tu fais ou ce que tu vends, et pour qui.",
  "content.aboutMore": "Plus de détails (facultatif)",
  "content.account": "Ton compte",
  "content.toLink": "À relier",
  "content.accountLead": "On lit tes dernières publications pour comparer chaque vidéo à tes vues habituelles. Rien n'est publié.",
  "content.handle": "@ton_compte",
  "content.link": "Relier mon compte",
  "content.refresh": "Relire mes chiffres",
  "content.change": "Changer",
  "content.forget": "Oublier ce compte",
  "content.usual.one": "{n} vue habituelle",
  "content.usual": "{n} vues habituelles",
  "content.top": "Tes vidéos les plus vues",
  "content.video": "Vidéo",
  "content.understood": "Ce que l'IA a compris",
  "content.understoodNone": "Monte et publie quelques vidéos : on te dira ce qui marche chez toi.",
  "content.understoodReady": "Tes vidéos suffisent pour un premier portrait.",
  "content.strengths": "Ce qui marche",
  "content.improve": "À travailler",
  "content.topics": "Tes sujets",
  "content.basedOn.one": "D'après {n} vidéo",
  "content.basedOn": "D'après {n} vidéos",
  "content.update": "Mettre à jour",
  "content.write": "Le faire maintenant",
  "content.later": "Réessaie dans un instant.",
  "content.connected": "Comptes connectés",
  "content.connectedNone": "Aucun",
  "content.connectedLead": "Connecte ton compte pour voir ce qu'on ne lit pas de l'extérieur : les abonnés gagnés par vidéo, la part regardée, le temps regardé.",
  "content.connect": "Connecter",
  "content.reconnect": "Reconnecter",
  "content.disconnect": "Déconnecter",
  "content.resync": "Relire maintenant",
  "content.soon": "Bientôt",
  "content.soonWhy": "Dès que {name} aura validé EditIT.",
  "content.expired": "L'accès a expiré : reconnecte-le pour relire tes chiffres.",
  "content.inside": "Ce que {name} voit de tes vidéos",
  "content.insideFoot": "Chiffres de {name}, tels quels.",
  "content.gained.one": "+{n} abonné",
  "content.gained": "+{n} abonnés",
  "content.lost.one": "{n} désabonné",
  "content.lost": "{n} désabonnés",
  "content.watched": "{n} % regardés",
  "content.avgView": "{n} s en moyenne",
  "content.completed": "{n} % vont au bout",
  "content.reach": "{n} comptes touchés",
  "content.saves.one": "{n} enregistrement",
  "content.saves": "{n} enregistrements",
  "content.promoted": "boostée",
  "content.followers": "{n} abonnés",
  "content.connectedOk": "{name} est connecté.",
  "content.connectDenied": "Connexion annulée : rien n'a été partagé.",
  "content.connectFailed": "La connexion n'a pas abouti. Réessaie dans un instant.",
  // Publier, commentaires, messages (features/social).
  "nav.comments": "Commentaires",
  "export.publish": "Publier sur mes comptes",
  "social.publish.title": "Publier",
  "social.publish.where": "Où",
  "social.publish.none": "Connecte un compte YouTube, Instagram ou TikTok pour publier d'ici.",
  "social.publish.connect": "Connecter un compte",
  "social.publish.soon": "Bientôt",
  "social.publish.notExported": "Exporte d'abord la vidéo : c'est elle qui part.",
  "social.publish.export": "Exporter",
  "social.publish.caption": "Légende",
  "social.publish.captionPlaceholder": "Ce que tu veux dire avec la vidéo…",
  "social.publish.titleField": "Titre sur YouTube",
  "social.publish.visibility": "Visibilité",
  "social.publish.visibility.public": "Publique",
  "social.publish.visibility.unlisted": "Non répertoriée",
  "social.publish.visibility.private": "Privée",
  "social.publish.when": "Quand",
  "social.publish.now": "Maintenant",
  "social.publish.later": "Plus tard",
  "social.publish.zone": "Heure de {zone}",
  "social.publish.go": "Publier",
  "social.publish.goLater": "Programmer",
  "social.publish.pick": "Choisis au moins un compte.",
  "social.publish.sent": "Envois",
  "social.state.waiting": "En attente",
  "social.state.scheduled": "Programmé · {when}",
  "social.state.sending": "Envoi en cours",
  "social.state.processing": "{name} prépare la vidéo",
  "social.state.published": "Publié",
  "social.state.failed": "Erreur",
  "social.state.cancelled": "Annulé",
  "social.post.open": "Voir",
  "social.post.retry": "Relancer",
  "social.post.cancel": "Annuler l'envoi",
  "social.post.uncertain": "Vérifie d'abord sur {name} : la vidéo est peut-être partie.",
  "social.inbox.title": "Commentaires",
  "social.inbox.comments": "Commentaires",
  "social.inbox.messages": "Messages",
  "social.inbox.pending": "À répondre · {n}",
  "social.inbox.all": "Tous",
  "social.inbox.allPosts": "Toutes les vidéos",
  "social.inbox.refresh": "Actualiser",
  "social.inbox.empty": "Rien à répondre pour l'instant.",
  "social.inbox.emptyAll": "Pas encore de commentaires ici. Touche Actualiser pour les relire.",
  "social.inbox.noAccount": "Connecte Instagram, YouTube ou TikTok pour lire et répondre aux commentaires ici.",
  "social.inbox.live": "Les nouveaux commentaires arrivent seuls.",
  "social.comment.reply": "Répondre",
  "social.comment.suggest": "Proposer une réponse",
  "social.comment.suggestNote": "Proposée par EditIT : relis-la avant d'envoyer.",
  "social.comment.send": "Envoyer",
  "social.comment.hide": "Masquer",
  "social.comment.unhide": "Afficher",
  "social.comment.pin": "Épingler",
  "social.comment.unpin": "Désépingler",
  "social.comment.delete": "Supprimer",
  "social.comment.deleteConfirm": "Supprimer ce commentaire ?",
  "social.comment.deleteLead": "C'est définitif, sur {name} aussi.",
  "social.comment.hidden": "Masqué",
  "social.comment.pinned": "Épinglé",
  "social.comment.you": "Toi",
  "social.comment.placeholder": "Ta réponse, visible de tous…",
  "social.comment.toAnswer": "À répondre",
  "social.auto.button": "Réponse automatique",
  "social.auto.on": "Réponse automatique active",
  "social.auto.lead": "Quand quelqu'un écrit un mot-clé en commentaire, il reçoit ce message en privé.",
  "social.auto.keywords": "Mots-clés, séparés par des virgules",
  "social.auto.keywordsPlaceholder": "GUIDE, lien",
  "social.auto.match": "Le commentaire",
  "social.auto.match.word": "contient le mot",
  "social.auto.match.contains": "contient le texte",
  "social.auto.match.exact": "est exactement",
  "social.auto.typos": "Accepter une faute de frappe",
  "social.auto.exclude": "Sauf si le commentaire contient",
  "social.auto.dm": "Message privé envoyé",
  "social.auto.dmPlaceholder": "Voici le guide promis : …",
  "social.auto.reply": "Réponse publique sous le commentaire (facultatif)",
  "social.auto.replyPlaceholder": "Envoyé en message privé !",
  "social.auto.enabled": "Active",
  "social.auto.save": "Enregistrer",
  "social.auto.remove": "Retirer",
  "social.auto.stats": "{triggered} déclenchées · {sent} envoyées · {misses} sans mot-clé",
  "social.auto.only": "Les réponses automatiques existent seulement sur Instagram.",
  "social.dm.empty": "Pas encore de messages.",
  "social.dm.placeholder": "Ton message…",
  "social.dm.closed": "Plus de 7 jours : la personne doit t'écrire de nouveau.",
  "social.dm.late": "Plus de 24 h : tu peux encore répondre quelques jours.",
  "social.dm.auto": "Réponse automatique",
  "social.dm.back": "Conversations",
  "social.dm.none": "Les messages privés existent seulement sur Instagram. Connecte ton compte Instagram pour les lire ici.",
  "memory.title": "Ce que l'IA retient",
  "memory.row": "Ce que l'IA retient de toi",
  "memory.lead": "Ton monteur s'en sert à chaque montage, à chaque retour et pour tes idées. Tout se corrige ici.",
  "memory.user": "Qui je suis",
  "memory.userHint": "Ton métier, ton sujet, ton public, ton ton.",
  "memory.editing": "Mes préférences de montage",
  "memory.editingHint": "Coupes, silences, sous-titres, musique, longueur…",
  "memory.empty": "Rien pour l'instant.",
  "memory.add": "Ajouter",
  "memory.addUser": "Ex. : Je suis coach de golf, je parle à des débutants",
  "memory.addEditing": "Ex. : Jamais d'emoji dans les sous-titres",
  "memory.edit": "Corriger",
  "memory.remove": "Retirer",
  "memory.usage": "{used} / {budget} caractères",
  "memory.pending": "{n} retours attendent d'être relus : ce qui revient sera retenu.",
  "memory.pending.one": "Un retour attend d'être relu : ce qui revient sera retenu.",
  "memory.reviewDone": "Après tes retours du {date} : {n} souvenirs retenus.",
  "memory.reviewDone.one": "Après tes retours du {date} : un souvenir retenu.",
  "memory.reviewNothing": "Tes retours du {date} ont été relus : rien de durable à retenir.",
  "memory.reviewFailed": "Tes retours du {date} n'ont pas pu être relus.",
  "memory.history": "Historique",
  "memory.byYou": "Toi",
  "memory.byReview": "L'IA, après tes retours",
  "memory.restore": "Remettre comme avant",
  "memory.historyEmpty": "Aucun changement pour l'instant.",
  "memory.style": "Ton style",
  "memory.styleLead": "Tiré de tes vidéos publiées qui marchent le mieux, comparées aux plus faibles. Le montage s'en sert seulement quand tu choisis « Comme mes meilleures vidéos ».",
  "memory.styleAnalyze": "Regarder mes vidéos",
  "memory.styleAgain": "Refaire l'analyse",
  "memory.styleRunning": "Je regarde tes vidéos… (une minute ou deux)",
  "memory.styleNoAccount": "Relie ton compte dans Réglages › Ton contenu pour que je regarde tes vidéos.",
  "memory.styleTooFew": "Il faut au moins cinq vidéos publiques pour comparer les meilleures aux plus faibles.",
  "memory.styleNoAi": "L'analyse de style n'est pas disponible pour l'instant.",
  "memory.style.rhythm": "Rythme",
  "memory.style.length": "Longueur",
  "memory.style.captions": "Sous-titres",
  "memory.style.hook": "Accroche",
  "memory.style.music": "Musique",
  "memory.style.avoid": "À éviter",
  "memory.style.summary": "En bref",
  "memory.styleEdited": "Corrigée par toi",
  "memory.styleBest": "Meilleure",
  "memory.styleWeakest": "Plus faible",
  "memory.styleViews": "{n} vues",
  "memory.styleRemove": "Effacer la fiche",
  "flow.style.likeMyBest": "Comme mes meilleures vidéos",
  "flow.style.likeMyBestHint": "Le rythme, la longueur et l'accroche de tes vidéos qui marchent.",
  "flow.pret.likeMyBest": "comme mes meilleures vidéos",
  "pro.tracks": "Pistes",
  "pro.tracks.hint": "Coupée ou masquée, une piste garde tout ce qu'elle contient : rallume-la pour le retrouver. Verrouillée, elle ne se modifie plus à la main.",
  "track.video": "Vidéo",
  "track.text": "Textes",
  "track.elements": "Éléments",
  "track.cutaways": "Plans de coupe",
  "track.sfx": "Sons",
  "track.music": "Musique",
  "track.voiceovers": "Voix off",
  "track.mute": "Son",
  "track.hide": "Image",
  "track.lock": "Verrou",
  "track.done": "Piste {name} : {what}",
  "track.on.mute": "coupée",
  "track.off.mute": "son rallumé",
  "track.on.hide": "masquée",
  "track.off.hide": "affichée",
  "track.on.lock": "verrouillée",
  "track.off.lock": "déverrouillée",
  "track.locked": "La piste {name} est verrouillée. Déverrouille-la dans Pistes pour la modifier.",
  "marker.add": "Poser un repère",
  "marker.added": "Repère posé à {t}",
  "marker.exists": "Il y a déjà un repère ici.",
  "marker.go": "Aller au repère",
  "marker.rename": "Renommer",
  "marker.moveHere": "Déplacer à la tête de lecture",
  "marker.remove": "Retirer",
  "marker.name": "Nom du repère",
  "marker.removed": "Repère retiré",
  "marker.moved": "Repère déplacé à {t}",
  "marker.renamed": "Repère renommé",
  "seq.title": "Séquences",
  "seq.main": "Principale",
  "seq.new": "Nouvelle séquence (copie de celle-ci)",
  "seq.newPrompt": "Nom de la nouvelle séquence (ex. Version courte)",
  "seq.hint": "Comme dans Premiere : plusieurs timelines du même montage (version courte, longue, autre format), chacune à part.",
  "seq.current": "À l'écran",
  "kf.title": "Images clés",
  "kf.count": "{n} image(s) clé(s)",
  "kf.add": "Ici",
  "kf.previous": "Précédente",
  "kf.next": "Suivante",
  "kf.remove": "Retirer",
  "kf.clear": "Tout retirer",
  "kf.x": "Gauche · droite",
  "kf.y": "Haut · bas",
  "kf.scale": "Taille",
  "kf.opacity": "Opacité",
  "kf.set": "Image clé posée à {t}",
  "kf.removed": "Image clé retirée",
  "kf.cleared": "Images clés retirées : l'élément reste à sa place",
  "kf.outside": "Place la tête de lecture sur l'élément pour y poser une image clé.",
  "look.title": "Fond et cadre",
  "look.chroma": "Fond retiré",
  "look.none": "Aucun",
  "look.green": "Vert",
  "look.blue": "Bleu",
  "look.strength": "Force",
  "look.crop": "Recadrer",
  "look.top": "Haut",
  "look.bottom": "Bas",
  "look.left": "Gauche",
  "look.right": "Droite",
  "look.done": "Incrustation réglée",
  "detach": "Détacher le son",
  "detach.done": "Son détaché : glisse-le ou rogne-le sur sa piste",
  "detach.speed": "Remets ce plan à la vitesse normale (1×) pour détacher son son.",
  "detach.silent": "Ce plan est muet : il n'a pas de son à détacher.",
  "clip.copy": "Copier",
  "clip.copied": "« {name} » copié : place la tête de lecture et colle-le",
  "clip.paste": "Coller à la tête de lecture",
  "clip.pasted": "Collé à {t}",
  "multi.mode": "Sélection multiple",
  "multi.count": "{n} choisi(s)",
  "multi.empty": "Clique les éléments à choisir (ou Maj + clic)",
  "multi.copy": "Copier",
  "multi.remove": "Supprimer",
  "multi.clear": "Désélectionner",
  "multi.done": "OK",
  "multi.removed": "{n} élément(s) supprimé(s)",
  "multi.none": "Rien à supprimer ici (il reste toujours au moins un plan).",
  "multi.reset": "Réinitialiser",
  "multi.resetDone": "{n} plan(s) remis à zéro : vitesse, son, image et cadrage d'origine",
  "multi.resetNone": "Aucun des plans choisis n'a de réglage à remettre.",
  "freeze": "Figer",
  "freeze.done": "Image figée {s} s à {t}",
  "freeze.fail": "L'image n'a pas pu être figée. Réessaie un peu plus loin dans le plan.",
  "freeze.photo": "Ce plan est déjà une photo : duplique-le pour le tenir plus longtemps.",
  "freeze.where": "Place la tête de lecture sur un plan.",
  "freeze.hold": "Durée de l'image figée",
  "insert": "Insérer",
  "insert.done": "Média inséré à {t}",
  "insert.fail": "Ce média n'a pas pu être inséré. Réessaie, ou choisis-en un autre.",
  "insert.sending": "Envoi… {n} %",
};

export type Key = keyof typeof fr;


export type Lang = "fr" | "en";
/** L'anglais arrive avec loadDicts() ; en attendant, une clé manquante retombe sur le français. */
export const dicts: Record<Lang, Record<Key, string>> = { fr, en: {} as Record<Key, string> };

/** Charge les textes anglais (à attendre avant d'afficher l'app en anglais ; les tests et l'export l'appellent aussi). */
export async function loadDicts(): Promise<void> {
  if (Object.keys(dicts.en).length) return;
  dicts.en = (await import("./i18n-en.js")).en;
}

export function detectLang(languages: readonly string[] = typeof navigator !== "undefined" ? navigator.languages ?? [navigator.language] : []): Lang {
  for (const l of languages) {
    const base = l.toLowerCase().slice(0, 2);
    if (base === "fr") return "fr";
    if (base === "en") return "en";
  }
  return "en";
}

export let lang: Lang = detectLang();
export function setLang(l: Lang) {
  lang = l;
}

/** Traduit une clé, en remplaçant les {variables}. */
export function t(key: Key, vars?: Record<string, string | number>, l: Lang = lang): string {
  let s = dicts[l][key] ?? fr[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}

/**
 * Un texte qui dépend d'un nombre : la clé `….one` au singulier, la clé elle-même au pluriel.
 * En français, 0 et 1 sont au singulier (« 0 plan vu »), en anglais seulement 1.
 */
export function tn(key: Key, n: number, vars?: Record<string, string | number>, l: Lang = lang): string {
  const one = `${key}.one` as Key;
  const singular = l === "fr" ? Math.abs(n) < 2 : n === 1;
  return t(singular && one in dicts[l] ? one : key, { n, ...vars }, l);
}

/** Un nombre écrit à la manière de la langue (« 0,02 » en français, « 0.02 » en anglais). */
export function num(n: number, digits = 1, l: Lang = lang): string {
  return new Intl.NumberFormat(l === "fr" ? "fr-FR" : "en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(n);
}

/** « 1,5 s » (« 1.5 s » en anglais) : une durée courte, à la décimale. */
export function seconds1(x: number, l: Lang = lang): string {
  return `${num(x, 1, l)} s`;
}

/** « 2 s », « 0,5 s » : une durée courte au dixième, sans « ,0 » inutile (cases d'un template, fondus, extraits). */
export function secondsShort(x: number, l: Lang = lang): string {
  const r = Math.round(x * 10) / 10;
  return `${Number.isInteger(r) ? r : num(r, 1, l)} s`;
}

/** Un nombre de Go, Mo ou Ko comme le Finder et Photos l'arrondissent : une décimale sous 10, aucune au-delà. */
export function sizeAmount(x: number): string {
  return new Intl.NumberFormat(lang, { maximumFractionDigits: x < 10 ? 1 : 0 }).format(x);
}

/** « 81 Mo », « 1,2 Go » : la place prise par un fichier ou un montage, comme sous les cartes d'Edits. */
export function fileSize(bytes: number): string {
  const unit = { kb: t("size.kb"), mb: t("size.mb"), gb: t("size.gb") };
  if (bytes >= 1024 ** 3) return `${sizeAmount(bytes / 1024 ** 3)} ${unit.gb}`;
  if (bytes >= 1024 ** 2) return `${sizeAmount(bytes / 1024 ** 2)} ${unit.mb}`;
  return `${sizeAmount(Math.max(1, bytes / 1024))} ${unit.kb}`;
}

/** « 1:05 » : le temps d'une vidéo, comme sur un lecteur (tronqué, jamais arrondi : 0:59,9 reste 0:59). */
export function clock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

/** « 30 sept. » : une date courte, dans la langue de l'interface. */
export function shortDate(iso: string, l: Lang = lang): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : new Intl.DateTimeFormat(l === "fr" ? "fr-FR" : "en-US", { day: "numeric", month: "short" }).format(d);
}

export function ago(iso: string, now = Date.now(), l: Lang = lang): string {
  const min = Math.floor((now - Date.parse(iso)) / 60_000);
  if (!(min >= 1)) return t("time.justNow", undefined, l);
  if (min < 60) return t("time.minutes", { n: min }, l);
  if (min < 48 * 60) return t("time.hours", { n: Math.floor(min / 60) }, l);
  return t("time.days", { n: Math.floor(min / 1440) }, l);
}
